import { buildRegionBatches } from './batch-region-requests'
import { NotificationService } from 'src/app/signalr/notification.service';
import { ElementTypeOptionsUtil } from 'src/app/shared/utils/element-type-options.util';
import { HostListener, Injector, Injectable, OnDestroy, inject } from '@angular/core';
import { ReferenceDateBridgeService } from 'src/app/shared/services/reference-date-bridge.service';
import { Util } from '@phdsoft/common';
import { CollectionService } from '../collections/collection.service';
import { CollectionInfoModel } from 'projects/phdsoft/common/src/lib/models/collection-info.model';
import { CollectionStaticData } from '../collections/_utils/collection.static.data';
import { DigitalTwinService } from '../digital-twin/digital-twin.service';
import * as THREE from '@phdsoft/three';
import { CollectionBlobInfoModel } from 'projects/phdsoft/common/src/lib/models';
import { ColorMapKeywords } from '../digital-twin/Three/Lut';
import { DocumentsListService } from '../template/documents/documents-list/documents-list.service';
import { TemplateService } from '../template/template.service';
import { AssetManagerRepair } from './asset-manager-repair';
import { AssetManagerInspection } from './asset-manager-inspection';
import { AssetManagerDownloadedInspection } from './asset-manager-downloaded-inspection';
import { Asset } from '../platform/busines-data/Framework/Asset';
import { GraphicsMaterials } from '../digital-twin/graphics/graphics-materials';
import { GraphicsRenderDocuments } from '../digital-twin/graphics/graphics-render-documents';
import { GaugingElement } from '../platform/busines-data/SectionElements/InspectionElements/gaugingElement';
import { Section } from '../platform/busines-data/Framework/Section';
import { InspectionCampaign } from '../platform/busines-data/Campaigns/InspectionCampaign';
import { v4 as uuid } from 'uuid';
import { Region } from '../platform/busines-data/Framework/Region';
import { Graphics } from '../digital-twin/graphics/graphics';
import { SteelThicknessGaugingPoint } from '../platform/busines-data/SectionElements/InspectionElements/steelThicknessGaugingPoint';
import { StructuralElement } from '../platform/busines-data/SectionElements/StructureElements/StructuralElement';
import { CameraControl } from '../digital-twin/graphics/graphics-camera-controler.service';
import { WorkableElement } from '../platform/busines-data/SectionElements/WorkableElement';
import { LinearElement } from '../platform/busines-data/SectionElements/StructureElements/LinearElement';
import { computeRecompartmentActions, leavesLoadedScene } from './recompartment/recompartment-actions';
import { describeRecompartmentResult, GltfRegionFailure, RecompartmentElementResult } from './recompartment/recompartment-result';
import { applyInspectionLinks } from './recompartment/checklist-links';
import { rehomePointInstance, removePointInstance } from './recompartment/recompartment-point-instances';
import { RepairCampaign } from '../platform/busines-data/Campaigns/RepairCampaign';
import { RegionsService } from '../admin/services/regions.service';
import { ELEMENTSTYPESIDS } from 'projects/phdsoft/common/src/lib/shared/constants/elementsTypesIds';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { AnomalyModel } from 'projects/phdsoft/common/src/lib/models/anomaly.model';
import moment from 'moment';
import { AnomalyService } from '../admin/services/anomaly.service';
import { PropertyDefinitionModel } from 'projects/phdsoft/common/src/lib/models/property-definition.model';
import { CompositePropertyModel } from 'projects/phdsoft/common/src/lib/models/composite-property.model';
import { ElementTypeModel } from 'projects/phdsoft/common/src/lib/models/element-type.model';
import { CompositePropertyValueModel } from 'projects/phdsoft/common/src/lib/models/composite-property-value';
import { ProtectionElementsCampaign } from '../platform/busines-data/Campaigns/ProtectionElementsCampaign';
import { CriticalAreaCampaign } from '../platform/busines-data/Campaigns/CriticalAreaCampaign';
import { DegradationCurveParameters, StructureDegradationParameters } from '../degradation/models/degradation-curve';
import { DegradationParametersLoaderService } from '../degradation/degradation-parameters-loader.service';
import { IFilter } from '../filter/filter.component';
import { CriticalAreaElement } from '../platform/busines-data/CriticalAreaElement/CriticalAreaElement';
import { InspectionPlanService } from '../inspection-plan/inspection-plan.service';
import { AssetInfoViewService } from '../template/asset-info-view/asset-info-view/asset-info-view.service';
import { IInspectionPlan } from '../inspection-plan/inspection-plan.interface';
import { IProps } from '../inspection-list/inspection-list/inspection-list.component';
import { mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import { DisplayDegradationCurveEvent } from '../degradation/models/display-degradation-curve-event';
import { BaseboardInspectionListComponent } from '../template/baseboard/baseboard-inspection-list/baseboard-inspection-list.component';
import { DegradationUtil } from '../degradation/degradation-utils';
import { FilterService } from '../filter/filter.service';
import { ChangesModel } from 'projects/phdsoft/common/src/lib/models/changes.model';
import { INSPECTIONS_TYPES_IDS } from 'projects/phdsoft/common/src/lib/shared/constants/inspections-types-ids';
import { takeUntil } from 'rxjs/operators';
import { INSERTIONCONSTANTS } from 'projects/phdsoft/common/src/lib/shared/constants/insertions-constants';
import { AssetService } from '../shared/services/asset.service';
import { ExcelService } from '../export-import/excel/excel.service';
import { InvalidElementDTO } from '../export-import/dto/invalid-element.dto';
import { CriticalAreaService, RegionsAndSectionsRisk, RegionRisk } from '../template/critical-area-window/critical-area.service';
import { getUVSValues } from '../digital-twin/MeshUtils/DataTextureUtils';
import { RiskLevelService } from '../admin/pages/risk-setup/service/risk-level.service';
import { RiskLevelItem } from '../admin/pages/risk-setup/types/risk-config.model';
import { ElementResultInfo } from 'projects/phdsoft/common/src/lib/models/element-result-info.model';
import { PointsRender } from '../digital-twin/utmPoints/graphics-render-pointShape';
import { CrudBasicDomains } from 'projects/phdsoft/common/src/lib/models/crud-basic-domains.model';
import { CrudBasicDomainsService } from '../admin/services/crud-basic-domains.service';
import { ViewModeStructureLabelsService } from '../template/view-mode-tools/view-mode-structure-labels/view-mode-structure-labels.service';
import { TypicalDetailsLabelsService } from '../template/view-mode-tools/view-mode-typical-details-labels/typical-details-labels.service';
import { TracingModel } from 'projects/phdsoft/common/src/lib/models/tracing.model';
import { ChecklistItem } from '@app/collections/collection-inspection/_models/checklist.model';
import { ReferenceDateEventsService } from '../template/view-mode-tools/view-mode-anomaly-labels/reference-date-events.service';
import { GraphicsRenderRuler } from '../digital-twin/graphics/graphics-render-ruler';
import { InspectionPointInstanceManager } from '../digital-twin/graphics/inspection-point-instance-manager.service';

export type FunctionalityMode = 'INSPECTIONINSERTION' |
  'SENSORINSERTION' |
  'NONE' |
  'MANUALREPAIR' |
  'SPLITMANUALREPAIR' |
  'STIFFNERINSERTION' |
  'WELDINGINSERTION' |
  'ZOOMBOX' |
  'MEASURETOOLS' |
  'MULTIPLESELECTION' |
  'MULTIPLESTRUCTURESELECTION' |
  'ELEMENTINSERTION' |
  'SPLITCRITICALAREA' |
  'CRITICALAREA' |
  'CRITICALAREAVOLUME' |
  'BOXWEIGHTTOOL' |
  'CONNECTION_BBOX' |
  'INSPECSELECTCHANGE' |
  'INSPECCHANGETARGET' |
  'INSPECTIONPOINTMOVE' |
  'COMPLETEDFULLIDSWEB' |
  'COMPLETEDFULLIDSFLANGE' |
  'FULLIDSELEMENTS' |
  'FULLIDSELEMENTTARGET' |
  'SECTIONCREATIONELEMENTS' |
  'JOINFLANGES' |
  'CUTPLATE' |
  'CUTPLATESHAPE' |
  'MERGEPLATE' |
  'SUBMODEL_NAVIGATION' |
  'MATERIALEDIT' |
  'DRONEFLIGHTPLAN' |
  'DRONEINSPECTIONROUTE';

/** Outcome of `AssetManager.recompartmentElement`, emitted on `recompartmentFinished$`. */
export interface RecompartmentFinishedEvent {
  elementId: string
  /** ThreeD moved the element. */
  ok: boolean
  /** The element left every loaded region; whatever selection points at it must be closed. */
  selectionDisposed: boolean
}

/** A region whose GLTF failed after a recompartment, kept for the "Regenerate 3D" action. */
export interface RecompartmentGltfFailure extends GltfRegionFailure {
  assetId: string
  elementId: string
}

@Injectable({ providedIn: 'root' })
export class AssetManager implements OnDestroy {
  ColorsMap: ColorMapKeywords;
  currentRegionIds: any
  assetName: string
  regionName: string
  sectionName: string
  listInspectionTypesToTimeline: any
  plans: IInspectionPlan[]
  historicalPlans: Partial<IInspectionPlan>[]
  filters: IFilter[]
  inspectionTypesToTimeline: any
  inspectionProps: IProps
  isNavigationSectionAvailable: boolean = false;
  baseboardInspectionList: BaseboardInspectionListComponent
  actionPlanAreas: WorkableElement[];
  criticalAreasActionPlans = new Map<string, IInspectionPlan>();
  listActionInspectionPlan: IInspectionPlan[];

  regionsRiskLevels: RegionRisk[] = [];
  redRiskMinArea: number
  redRiskMaxArea: number

  riskLevels: RiskLevelItem[]
  private _riskLevelsLoaded: boolean = false
  /** Bumped per risk load and on invalidation, so a load that started before a critical area change is discarded. */
  private _riskLevelsLoadSeq = 0
  public get riskDataLoaded(): boolean {
    return this._riskLevelsLoaded;
  }

  private _filterList: IFilter[] = <IFilter[]>[]
  public get filterList(): IFilter[] {
    return this._filterList;
  }
  public set filterList(v: IFilter[]) {
    this._filterList = v;
  }

  public get clusters() {
    return this.filterList?.filter(f => f.isCluster)
  }



  private _loadCurrentCluster: boolean;
  public get loadCurrentCluster(): boolean {
    return this._loadCurrentCluster;
  }
  public set loadCurrentCluster(v: boolean) {
    this._loadCurrentCluster = v;
  }

  private _currentSection: Section;
  public get currentSection(): Section {
    return this._currentSection;
  }
  public set currentSection(v: Section) {
    this._currentSection = v;
  }


  private _currentRegion: Region;
  public get currentRegion(): Region {
    return this._currentRegion;
  }
  public set currentRegion(v: Region) {
    this._currentRegion = v;
  }  

  private _tracingData: TracingModel[] = [];
  public get tracingData(): TracingModel[] {
    return this._tracingData;
  }
  public set tracingData(v: TracingModel[]) {
    this._tracingData = v;
  }

  private _tracingDataLoaded: boolean = false;
  public get tracingDataLoaded(): boolean {
    return this._tracingDataLoaded;
  }
  public set tracingDataLoaded(v: boolean) {
    this._tracingDataLoaded = v;
  }

  public settingTracingData:boolean = false;

  public currentSelectedElementChanged = new BehaviorSubject<boolean>(false);
  public currentSelectedElementChangedElement = new BehaviorSubject<WorkableElement>(null);
  public onAssetLoaded = new Subject<Asset>();

  public isCutFinished = new BehaviorSubject<boolean>(false);
  public isMergeFinished = new BehaviorSubject<boolean>(false);
  public isMergePlateInProgress = false;
  public isLoading = new BehaviorSubject<boolean>(false);
  private _currentSelectedElement: WorkableElement;
  public get currentSelectedElement(): WorkableElement {
    return this._currentSelectedElement;
  }
  public set currentSelectedElement(v: WorkableElement) {
    this._currentSelectedElement = v;
    this.asset.currentSelectedElement = v;
    this.currentSelectedElementChanged.next(true);
    this.currentSelectedElementChangedElement.next(v);
  }

  public setCutFinished(v: boolean){
    this.isCutFinished.next(v);
  }

  public setMergeFinished(v: boolean){
    this.isMergeFinished.next(v);
  }

  public resetMergePlateState(): void {
    this.platesToMerge = [];
    this.isMergePlateInProgress = false;
    this.setMergeFinished(false);
  }

  public setIsLoading(v: boolean){
    this.isLoading.next(v);
  }
  public setCurrentSelectedElement(v: WorkableElement){
    this._currentSelectedElement = v;
    this.asset.currentSelectedElement = v;
  }

  private _referenceDate: Date;
  private readonly referenceDateBridge = inject(ReferenceDateBridgeService);
  public get referenceDate(): Date {
    return this._referenceDate;
  }
  public set referenceDate(v: Date) {
    this._referenceDate = v;
    this.referenceDateBridge.current = v;
  }

  private currentRegionId: string;
  public getCurrentRegionId(): string {
    return this.currentRegionId;
  }
  public currentRegionsIds: string[];

  private _functionalityMode: FunctionalityMode;


  private _elementsType: Array<string>;
  public get elementsType(): Array<string> {
    return this._elementsType;
  }
  public set elementsType(v: Array<string>) {
    this._elementsType = v;
  }

  private _asset: Asset;
  public get asset(): Asset {
    return this._asset;
  }
  public set asset(v: Asset) {
    this._asset = v;
  }


  private _isTouch: boolean = false;
  public get isTouch(): boolean {
    return this._isTouch;
  }
  public set isTouch(v: boolean) {
    this._isTouch = v;
  }

  private _currentInspectionTypeId: string;
  // Emits whenever currentInspectionTypeId changes. Used (e.g. by the Scout
  // POI inspector) to await a sideboard pick without polling. Initial value
  // is undefined so callers can `filter(id => !!id)` to ignore startup state.
  public readonly currentInspectionTypeId$ = new BehaviorSubject<string>(undefined);
  public get currentInspectionTypeId(): string {
    return this._currentInspectionTypeId;
  }
  public set currentInspectionTypeId(v: string) {
    this._currentInspectionTypeId = v;
    this.currentInspectionTypeId$.next(v);
  }
  
  private _geoElementsJSON : Record<string, any>;
  public get geoElementsJSON() : Record<string, any> {
    return this._geoElementsJSON;
  }
  public set geoElementsJSON(v : Record<string, any>) {
    this._geoElementsJSON = v;
  }

  private _currentWebCompletedId : WorkableElement;
  public get currentWebCompletedId() : WorkableElement {
    return this._currentWebCompletedId;
  }
  public set currentWebCompletedId(v : WorkableElement) {
    this._currentWebCompletedId = v;
  }

  private _currentFlangeCompletedId : WorkableElement;
  public get currentFlangeCompletedId() : WorkableElement {
    return this._currentFlangeCompletedId;
  }
  public set currentFlangeCompletedId(v : WorkableElement) {
    this._currentFlangeCompletedId = v;
  }

  private _fullIdsElements : Array<WorkableElement>;
  public get fullIdsElements() : Array<WorkableElement> {
    return this._fullIdsElements;
  }
  public set fullIdsElements(v : Array<WorkableElement>) {
    this._fullIdsElements = v;
  }

  private _fullIdElementTarget : WorkableElement;
  public get fullIdElementTarget() : WorkableElement {
    return this._fullIdElementTarget;
  }
  public set fullIdElementTarget(v : WorkableElement) {
    this._fullIdElementTarget = v;
  }

  private _newSectionElements : Array<WorkableElement>;
  public get newSectionElements() : Array<WorkableElement> {
    return this._newSectionElements;
  }
  public set newSectionElements(v : Array<WorkableElement>) {
    this._newSectionElements = v;
  }

  private _joinFlanges : Array<WorkableElement>;
  public get joinFlanges() : Array<WorkableElement> {
    return this._joinFlanges;
  }
  public set joinFlanges(v : Array<WorkableElement>) {
    this._joinFlanges = v;
  }

  private _platesToMerge : Array<WorkableElement>;
  public get platesToMerge() : Array<WorkableElement> {
    return this._platesToMerge;
  }
  public set platesToMerge(v : Array<WorkableElement>) {
    this._platesToMerge = v;
  }

  private _clickEvent : any;
  public get clickEvent() : any {
    return this._clickEvent;
  }
  public set clickEvent(v : any) {
    this._clickEvent = v;
  }



  private _currentMethodId: string;
  public get currentMethodId(): string {
    return this._currentMethodId;
  }
  public set currentMethodId(v: string) {
    this._currentMethodId = v;
  }

  private _tempInsertedPointsArray: Array<WorkableElement> = [];

  public get tempInsertedPointsArray(): Array<WorkableElement> {
    return this._tempInsertedPointsArray;
  }

  public set tempInsertedPointsArray(value: Array<WorkableElement>) {
    this._tempInsertedPointsArray = value;
  }

  private _selectedInspections: Array<WorkableElement> = [];

  public get selectedInspections(): Array<WorkableElement> {
    return this._selectedInspections;
  }
  public set selectedInspections(value: Array<WorkableElement>) {
    this._selectedInspections = value;
  }

  private _selectedElements: Array<WorkableElement> = [];
  /** Emits the full multi-selection every time `selectedElements` is reassigned. */
  public selectedElementsChanged = new BehaviorSubject<Array<WorkableElement>>([]);
  /**
   * "Select more" toggle in the properties window: while true, plain clicks/taps
   * in SECTIONS mode accumulate structural elements instead of replacing the
   * selection (same as Ctrl/Cmd+click, for touch). A boolean rather than a
   * functionality mode because enableMultipleSelection() overwrites
   * functionalityMode on every section entry.
   */
  public multiSelectEditActive: boolean = false;
  /**
   * Structure Types (TypeName labels, e.g. 'Plate') the user allowed in the "Select more"
   * Structure Type list. While multiSelectEditActive, only elements of these types can be
   * added by tap/click or rectangle drag; already-selected elements can always be removed.
   */
  public multiSelectAllowedTypes: string[] = [];

  /** True when `element` may be added to the multi-selection under the current type filter. */
  public isTypeAllowedForMultiSelect(element: any): boolean {
    return ElementTypeOptionsUtil.isTypeAllowed(element, this.multiSelectAllowedTypes);
  }

  /** Leaves "Select more" mode and drops its Structure Type filter. */
  public endMultiSelectEdit(): void {
    this.multiSelectEditActive = false;
    this.multiSelectAllowedTypes = [];
  }

  public get selectedElements(): Array<WorkableElement> {
    return this._selectedElements;
  }
  public set selectedElements(value: Array<WorkableElement>) {
    this._selectedElements = value ?? [];
    this.selectedElementsChanged.next(this._selectedElements);
  }

  public getRegionName(id: string): string {
    return this.asset.assetInfo.Regions.find(x => x.id === id)?.name;
  }

  public getSectionName(id: string): string {
    return this.asset.assetInfo.Sections.find(x => x.id === id)?.name;
  }

  private _assetProperties: PropertyDefinitionModel[] = [];

  public get assetProperties(): PropertyDefinitionModel[] {
    return this._assetProperties;
  }
  public set assetProperties(value: PropertyDefinitionModel[]) {
    this._assetProperties = value;
  }

  private _assetCompositeProperties: CompositePropertyModel[] = [];

  public get assetCompositeProperties(): CompositePropertyModel[] {
    return this._assetCompositeProperties;
  }

  public set assetCompositeProperties(value: CompositePropertyModel[]) {
    this._assetCompositeProperties = value;
  }

  private _assetElementTypes: ElementTypeModel[] = [];

  public get assetElementTypes(): ElementTypeModel[] {
    return this._assetElementTypes;
  }

  public set assetElementTypes(value: ElementTypeModel[]) {
    this._assetElementTypes = value;
  }

  private _assetCompositePropertiesValues: CompositePropertyValueModel[] = [];

  public get assetCompositePropertiesValues(): CompositePropertyValueModel[] {
    return this._assetCompositePropertiesValues;
  }

  public set assetCompositePropertiesValues(value: CompositePropertyValueModel[]) {
    this._assetCompositePropertiesValues = value;
  }

  private isAreaInsertion = false;

  public loadedStructureCollections = [];

  public listInpectionType: CrudBasicDomains[] = [];

  public degradationMode: boolean = false
  public updateChangesWorkflow: boolean = false

  private _inspectionElementsDegradationCurveParameters: DegradationCurveParameters[] = []

  public get inspectionElementsDegradationCurveParameters() : DegradationCurveParameters[] {
    return this._inspectionElementsDegradationCurveParameters;
  }
  public set inspectionElementsDegradationCurveParameters(v : DegradationCurveParameters[]) {
    this._inspectionElementsDegradationCurveParameters = v;

    for (const structureCampaign of this.asset.StructureCampaigns) {
      this.applyDegradationParametersToElements(structureCampaign.Elements);
    }

    for (const repairCampaign of this.asset.RepairCampaigns) {
      this.applyDegradationParametersToElements(repairCampaign.Elements);
    }
  }

  // Runs for every structural element on every assignment, so the per-element work has to stay
  // cheap: the normalised guid is computed once per element rather than once per curve
  // comparison, which is where a bulk delete used to spend most of its frozen main thread.
  private applyDegradationParametersToElements(elements: WorkableElement[]): void {
    const allCurves = this._inspectionElementsDegradationCurveParameters;

    for (const element of elements) {
      const parentGeometryId = element.Guid.replace(/-/g, '');
      const curves = allCurves.filter(p => p.ParentGeometryId == parentGeometryId);
      const validInspectionCurves = curves.filter(p => p.InspectionElementId != null && p.HasMeasurements);
      (element as StructuralElement).degradationParameters = validInspectionCurves.length > 0?validInspectionCurves:curves.filter(p => p.InspectionElementId == null);
    }
  }

  public get structureDegradationParametersList(): StructureDegradationParameters[] {
    let grouped = this.inspectionElementsDegradationCurveParameters.reduce((r, a) => {
      r[a.ParentGeometryId] = r[a.ParentGeometryId] || [];
      r[a.ParentGeometryId].push(a);
      return r;
    }, Object.create(null));

    let list = Object.keys(grouped).map(key => {

      var curves: DegradationCurveParameters[] = grouped[key]

      if (curves.length > 1) {
        curves = curves.filter(c => c.InspectionElementId != null)
      }

      let remainingLife = 0;

      if (curves.every(c => c.RemainingLife == Infinity)) {
        remainingLife = Infinity
      }
      else {
        const rLCurves = curves.filter(c => c.RemainingLife != Infinity)
        remainingLife = (rLCurves.reduce((prev, curr) => prev + curr.RemainingLife, 0)) / rLCurves.length;
      }

      const estimatedThickness = (curves.reduce((prev, curr) => prev + curr.EstimatedThickness, 0)) / curves.length;
      const corrosionRate = (curves.reduce((prev, curr) => prev + curr.CorrosionRate, 0)) / curves.length;
      const absoluteDegradation = (curves.reduce((prev, curr) => prev + curr.AbsoluteDegradation, 0)) / curves.length;

      return {
        ParentGeometryId: key,
        EstimatedThickness: estimatedThickness,
        RemainingLife: remainingLife,
        CorrosionRate: corrosionRate,
        AbsoluteDegradation: absoluteDegradation,
      }
    })
    return list
  }

  public assetChanges: ChangesModel[] = []

  public showComputeDimensions: boolean = false;
  public showDeleteElement: boolean = false;

  // Event emitter for excessive corrosion check to avoid circular dependency
  public excessiveCorrosionCheckRequested = new BehaviorSubject<GaugingElement | null>(null);

  constructor(
    public graphics: Graphics,
    private graphicsRenderDocuments: GraphicsRenderDocuments,
    private graphicsMaterials: GraphicsMaterials,
    public templateService: TemplateService,
    private collectionService: CollectionService,
    private regionsService: RegionsService,
    private documentsListService: DocumentsListService,
    private digitalTwinService: DigitalTwinService,
    private cameraControl: CameraControl,
    private assetManagerDownloadedInspection: AssetManagerDownloadedInspection,
    public noticationService: NotificationService,
    private assetService: AssetService,
    private anomalyService: AnomalyService,
    private assetInfoViewService: AssetInfoViewService,
    private inspectionService: InspectionPlanService,
    private crudService: CrudBasicDomainsService,
    private filterService: FilterService,
    private criticalAreaService: CriticalAreaService,
    private riskLevelService: RiskLevelService,
    private pointsRender: PointsRender,
    private viewModeStructureLabelsService: ViewModeStructureLabelsService,
    private typicalDetailsLabelsService: TypicalDetailsLabelsService,
    private referenceDateEventsService: ReferenceDateEventsService,
    private degradationParametersLoader: DegradationParametersLoaderService,
    private instanceManager: InspectionPointInstanceManager,
    private readonly injector: Injector,
  ) {
    this.defaultValues();
    // Set AssetManager reference in Graphics for label scale updates
    this.graphics.setAssetManager(this);
    // Risk colours are cached per asset; a critical area save/delete makes them stale.
    // Both services are root singletons, so this lives as long as the app.
    this.criticalAreaService.criticalAreasChanged$.subscribe(() => this.onCriticalAreasChanged());
  }

  // Subject to manage the unsubscription
  private destroy$ = new Subject<void>();

  @HostListener('unloaded')
  ngOnDestroy(): void {
    this.defaultValues();

    // Clean up structural labels service
    this.viewModeStructureLabelsService.dispose();

    // Emit a value to complete all observables
    this.destroy$.next();
    this.destroy$.complete();

    console.log('💣 Destroy AssetManager');
  }

  public async toggleDegradationMode() {
    if (!this.degradationMode)
      await this.estimateDegradationByCurveParameters()

    this.degradationMode = !this.degradationMode
    if (!this.degradationMode) {
      this.updateAllInspectionColor()
    }
  }

  defaultValues(): void {
    this.currentRegionsIds = [];
    this._functionalityMode = 'NONE';
    this.loadedStructureCollections = [];
    this.isAreaInsertion = false;
    this.tracingData = [];
    this.tracingDataLoaded = false;
    this.settingTracingData = false;
    this._riskLevelsLoaded = false;
  }

  public toggleDebugGui(): void {
    this.graphics.toggleStats();
  }

  public GetAssetInspectionTypes(): string[] {
    return this.asset.assetInfo.InspectionList;
  }

  public get IsAreaInsertion(): boolean {
    return this.isAreaInsertion;
  }
  public set IsAreaInsertion(v: boolean) {
    this.isAreaInsertion = v;
  }

  private ___currentInspectionCollection: InspectionCampaign;
  public get __currentInspectionCollection(): InspectionCampaign {
    return this.___currentInspectionCollection;
  }

  public set __currentInspectionCollection(value: InspectionCampaign) {
    this.___currentInspectionCollection = value;
  }


  private __currentRepairCampaign: RepairCampaign;
  public get _currentRepairCampaign(): RepairCampaign {
    return this.__currentRepairCampaign;
  }
  public set _currentRepairCampaign(v: RepairCampaign) {
    this.__currentRepairCampaign = v;
  }


  private __currentCriticalAreaCampaign: CriticalAreaCampaign;
  public get _currentCriticalAreaCampaign(): CriticalAreaCampaign {
    return this.__currentCriticalAreaCampaign;
  }
  public set _currentCriticalAreaCampaign(v: CriticalAreaCampaign) {
    this.__currentCriticalAreaCampaign = v;
  }

  private _currentProtectionElementsCampaign: ProtectionElementsCampaign;

  public get currentProtectionElementsCampaign(): ProtectionElementsCampaign {
    return this._currentProtectionElementsCampaign;
  }
  public set currentProtectionElementsCampaign(value: ProtectionElementsCampaign) {
    this._currentProtectionElementsCampaign = value;
  }

  public set functionalityMode(value: FunctionalityMode) {
    const prevMode = this._functionalityMode;
    if (prevMode === 'MERGEPLATE' && this.isMergePlateInProgress && value !== 'MERGEPLATE') {
      return;
    }

    this._functionalityMode = value;
    if (prevMode !== value) {
      this.injector.get(GraphicsRenderRuler).clearAreaDimensionRulers();
    }
    if ((prevMode === 'MANUALREPAIR' || prevMode === 'SPLITMANUALREPAIR') &&
      value !== 'MANUALREPAIR' &&
      value !== 'SPLITMANUALREPAIR') {
      this.injector.get(AssetManagerRepair).cancelRepairPreview();
      this.templateService.showRepairShapeSelectorComponent = false;
    }
    if (prevMode !== 'MERGEPLATE' && value === 'MERGEPLATE') {
      this.resetMergePlateState();
      this.templateService.showMergePlateComponent = true;
    }
    else if (prevMode === 'MERGEPLATE' && value !== 'MERGEPLATE') {
      this.resetMergePlateState();
      this.templateService.showMergePlateComponent = false;
    }

    // Leaving the "change inspection target" tool (not switching between its two pick steps).
    if ((prevMode === 'INSPECSELECTCHANGE' || prevMode === 'INSPECCHANGETARGET') &&
      value !== 'INSPECSELECTCHANGE' &&
      value !== 'INSPECCHANGETARGET') {
      this.injector.get(AssetManagerInspection).retarget?.cancel();
    }
  }

  public get functionalityMode(): FunctionalityMode {
    return this._functionalityMode;
  }

  private _collectionComponentEnableCurrentType: boolean = false;
  public get CollectionComponentEnableCurrentType(): boolean {
    return this._collectionComponentEnableCurrentType;
  }
  public set CollectionComponentEnableCurrentType(value: boolean) {
    this._collectionComponentEnableCurrentType = value;
  }

  private _elementTypeForInsertionAndSelectionGuid: string = '51b97c79cf164388b36bf8edc326887c'
  public get elementTypeForInsertionAndSelectionGuid(): string {
    return this._elementTypeForInsertionAndSelectionGuid;
  }

  private _auxiliaryOptionForInsertionAndSelection: string = '';
  public get auxiliaryOptionForInsertionAndSelection(): string {
    return this._auxiliaryOptionForInsertionAndSelection;
  }
  public set auxiliaryOptionForInsertionAndSelection(v: string) {
    this._auxiliaryOptionForInsertionAndSelection = v;
    if(v === ''){
      
    }
  }

  private _elementTypeForInsertionAndSelection: string = 'Plate';
  public get elementTypeForInsertionAndSelection(): string {
    return this._elementTypeForInsertionAndSelection;
  }
  public set elementTypeForInsertionAndSelection(v: string) {
    switch (v) {
      case 'Plate':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.PLATE;
        break;
      case 'Stiffener':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.STIFFENER;
        break;
      case 'FacePlate':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.FACEPLATE;
        break;
      case 'Bracket':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.BRACKET;
        break;
      case 'Concrete':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.CONCRETE;
        break;
      case 'Area':
        this._elementTypeForInsertionAndSelectionGuid = INSERTIONCONSTANTS.AREA;
        break;
      case 'Element':
        this._elementTypeForInsertionAndSelectionGuid = INSERTIONCONSTANTS.ELEMENT;
        break;
      case 'BeamPart':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.BEAMPART;
        break;
      case 'Cable':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.CABLE;
        break;
      case 'Pipe':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.PIPE;
        break;
      case 'Anode':
        this._elementTypeForInsertionAndSelectionGuid = ELEMENTSTYPESIDS.ANODE;
        break;
      default:
        break;
    }
    this._elementTypeForInsertionAndSelection = v;
  }

  private _elementTypeForSelection: string = '';
  public get elementTypeForSelection(): string {
    return this._elementTypeForSelection;
  }
  public set elementTypeForSelection(v: string) {
    this._elementTypeForSelection = v;
  }


  private _criticalAreaBox: THREE.Mesh<THREE.BoxGeometry, THREE.MeshStandardMaterial> = null

  public get criticalAreaBox(): THREE.Mesh<THREE.BoxGeometry, THREE.MeshStandardMaterial> {
    return this._criticalAreaBox
  }
  public set criticalAreaBox(box: THREE.Mesh<THREE.BoxGeometry, THREE.MeshStandardMaterial>) {
    if (this._criticalAreaBox || box == null) {
      this.graphics.scene.remove(this.criticalAreaBox)
      this._criticalAreaBox = box
    }
    this._criticalAreaBox = box
    this.graphics.scene.add(this.criticalAreaBox)
    this.graphics.requestRender();
  }

  public updateCriticalAreaBox(width: number, height: number, depth: number) {
    this.criticalAreaBox.geometry.dispose()
    this.criticalAreaBox.geometry = new THREE.BoxGeometry(width, height, depth);
    this.graphics.requestRender();
  }

  public changeToDefaultViewMode(): void {
    this.asset.viewMode = 'DEFAULT';
    this.graphicsMaterials.setStructureMaterialsVisibility(true);
    this.graphicsMaterials.setStructureMaterialsOpacity(1);
    this.asset.InspectionCampaigns.forEach(inspectionCampaig => {
      inspectionCampaig.group.visible = true;
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.group.visible = true;
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.changeStructureMaterials(GraphicsMaterials.basicMaterial);
    });
    if (this.asset.lightCampaign && this.asset.mode == 'MODEL') {
      this.graphicsMaterials.defaultViewModeLightModel(this.asset.GetStructureAndRepairsRegions());
      this.asset.GetLightModelMissingRegions();
    }
    else {
      this.graphicsMaterials.defaultViewMode(this.asset.GetStructureAndRepairsRegions());
    }
    this.asset.RepairCampaigns.forEach(repairsCampaig => {
      repairsCampaig.Elements.forEach(element => {
        element.SurfaceDesign.visible = true
      });
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.Elements.forEach(element => {
        element.SurfaceDesign.visible = true
      });
    });
    this.asset.CriticalAreaCampaigns.forEach(c => {
      c.Elements.forEach(element => {
        element.SurfaceDesign.material = element.defaultMaterial
        element.currentMaterial = element.defaultMaterial
      })
    })
    this.asset.SensorCampaign.changeSensorMaterials(GraphicsMaterials.sensorMaterial);
    this.graphics.disposeReferenceLines();
    
    // Deactivate typical details labels if active
    if (this.typicalDetailsLabelsService.isActive) {
      this.typicalDetailsLabelsService.deactivateTypicalDetailsLabels(this);
    }
  }

  public changeToLoadCycleClassificationViewMode(): void {
    this.asset.viewMode = 'LoadCycleClassification';
    this.asset.StructureCampaigns.forEach(campaign => {
      campaign.Elements.forEach(el => {
        el.SurfaceDesign.material = el.defaultMaterial;
        el.currentMaterial = el.defaultMaterial;
      });
    });
  }

  public async changeToReferenceElementViewMode(): Promise<void> {
    
    this.asset.viewMode = 'ReferenceElement';
    this.graphicsMaterials.setStructureMaterialsVisibility(true);
    this.graphicsMaterials.setStructureMaterialsOpacity(1);

    // console.log('changeToReferenceElementViewMode');
    const blobPath = this.asset.assetInfo.Collections[0].BlobPaths.find(item => item.RegionId == this._currentRegion.Guid);
    if(!this.geoElementsJSON){
      this.geoElementsJSON = {}
    }
    if (blobPath){
      let dataFile = null
      if(this.geoElementsJSON && this.geoElementsJSON[this._currentRegion.Guid] && this.geoElementsJSON[this._currentRegion.Guid].geometry
        && this.geoElementsJSON[this._currentRegion.Guid].geometry.length > 0
      ){
        dataFile = this.geoElementsJSON[this._currentRegion.Guid].geometry
      }
      else{
        let geometries = await this.regionsService.getFileRegion(blobPath.DefaultGeoPath);
        this.geoElementsJSON[this._currentRegion.Guid] = {id: this._currentRegion.Guid, geometry: geometries}
        dataFile = geometries
      }
      if(dataFile){ 
        const referenceLines = dataFile.filter(item => item.TypeId == ELEMENTSTYPESIDS.REFERENCELINE && 
          item.SectionId == this.currentSection.Guid);
        this.graphics.createReferenceLines(referenceLines, this.currentSection.getCenter());
      }
    }
  }

  public resetStructureMaterials(): void {
    this.asset.viewMode = 'DEFAULT';
    this.graphicsMaterials.setStructureMaterialsVisibility(true);
    this.graphicsMaterials.setStructureMaterialsOpacity(1);
    this.asset.InspectionCampaigns.forEach(inspectionCampaig => {
      inspectionCampaig.group.visible = true;
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.group.visible = true;
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.changeStructureMaterials(GraphicsMaterials.basicMaterial);
    });
    if (this.asset.lightCampaign && this.asset.mode == 'MODEL') {
      this.graphicsMaterials.defaultViewModeLightModel(this.asset.GetStructureAndRepairsRegions());
      this.asset.GetLightModelMissingRegions();
    }
    else {
      this.graphicsMaterials.resetStructureMaterials(this.asset.GetStructureAndRepairsRegions());
    }
    this.asset.RepairCampaigns.forEach(repairsCampaig => {
      repairsCampaig.Elements.forEach(element => {
        element.SurfaceDesign.visible = true
      });
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.Elements.forEach(element => {
        element.SurfaceDesign.visible = true
      });
    });
    this.asset.CriticalAreaCampaigns.forEach(c => {
      c.Elements.forEach(element => {
        element.SurfaceDesign.material = element.defaultMaterial
        element.currentMaterial = element.defaultMaterial
      })
    })
    this.asset.SensorCampaign.changeSensorMaterials(GraphicsMaterials.sensorMaterial);
  }
  public changeToRegionsViewMode(): void {
    this.asset.viewMode = 'RegionColor';
    console.log('🗺️ Alterando para modo de visualização por Região');
    if (this.asset.lightCampaign && this.asset.mode == 'MODEL') {
      this.graphicsMaterials.regionsViewModeLightModel(this.asset.GetStructureAndRepairsRegions());
    }
    else {
      this.graphicsMaterials.regionsViewMode(this.asset.GetStructureAndRepairsRegions());
    }
  }

  public completeIds(): void {
    this.asset.viewMode = 'CompletedIds';
    const regions = this.asset.GetStructureAndRepairsRegions();
    this.graphicsMaterials.completeIds(regions);
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(regions);
  }
  public fullIds(): void {
    this.asset.viewMode = 'FullIds';
    const regions = this.asset.GetStructureAndRepairsRegions();
    this.graphicsMaterials.fullIds(regions);
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(regions);
  }

  public flangeElementsView(): void {
    this.asset.viewMode = 'FlangeElementsView';
    const regions = this.asset.GetStructureAndRepairsRegions();
    this.graphicsMaterials.flangeElementsView(regions);
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(regions);
  }

  public stiffenersBracketsView(): void {
    this.asset.viewMode = 'StiffenersBracketsView';
    const regions = this.asset.GetStructureAndRepairsRegions();
    this.graphicsMaterials.stiffenersBracketsView(regions);
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(regions);
  }

  public filterLightSectionElementTypes(elementTypes: string[]): void {
    this.graphicsMaterials.filterLightSectionElementTypes(
      this.asset.GetStructureVisibleRegions(), elementTypes
    );
  }

  public typicalDetailsFamilyView(): void {
    this.asset.viewMode = 'TypicalDetailsFamily';
    this.graphicsMaterials.typicalDetailsFamilyView(this.asset.GetStructureAndRepairsRegions());
  }

  public changeToMaterialsViewMode(): void {
    this.asset.viewMode = 'MaterialColor';
    this.graphicsMaterials.materialsViewMode(this.asset.GetStructureAndRepairsRegions());
  }

  public changeToTransparenceViewMode(): void {
    this.asset.viewMode = 'Transparent';
    this.graphicsMaterials.transparenceViewMode(this.asset.GetStructureAndRepairsRegions());
  }

  public changeToThicknessTableViewMode(): void {
    this.asset.viewMode = 'ThicknessColor';
    this.graphicsMaterials.thicknessTableViewMode(this.asset.GetStructureAndRepairsRegions());
  }

  public changeToStructure4DViewMode(): void {
    this.asset.viewMode = 'Structure4D';
    this.graphicsMaterials.structure4DViewMode(this.asset.GetStructureAndRepairsRegions());
  }

  public changeToStructuralLabelViewMode(): void {
    this.asset.viewMode = 'StructuralLabel';
    this.viewModeStructureLabelsService.activateStructuralLabels(this);
    console.log('🏷️ Alterando para modo de visualização de Labels Estruturais');
  }

  public showStructuralLabels(elementType: string): void {
    this.viewModeStructureLabelsService.showStructuralLabels(this, elementType);
  }

  public getAvailableStructuralElementTypes(): string[] {
    return this.viewModeStructureLabelsService.getAvailableStructuralElementTypes(this);
  }

  public refreshStructuralLabels(): void {
    this.viewModeStructureLabelsService.refreshStructuralLabels(this);
  }

  public toggleXRayInspectionViewMode(value: boolean): void {
    if (value) {
      this.graphicsMaterials.setStructureMaterialsVisibility(false);
      this.asset.InspectionCampaigns.forEach(inspectionCampaig => {
        inspectionCampaig.group.visible = true;
      });
      return;
    }
    // Deactivate X-Ray Inspection View Mode
    this.graphicsMaterials.setStructureMaterialsVisibility(true);
    this.asset.InspectionCampaigns.forEach(inspectionCampaig => {
      inspectionCampaig.group.visible = true;
    });
  }

  public changeToInspectionViewMode(): void {
    this.asset.viewMode = 'Inspection';
  }

  public changeToXRayCriticalAreaViewMode(): void {
    this.asset.viewMode = 'Inspection';
    this.graphicsMaterials.setStructureMaterialsVisibilityCriticalArea(false);
    this.asset.InspectionCampaigns.forEach(inspectionCampaig => {
      inspectionCampaig.group.visible = false;
    });
    this.asset.CriticalAreaCampaigns.forEach(criticalAreaCampaign => {
      criticalAreaCampaign.group.visible = true;
    });
  }

  public changeToXRayRepairViewMode(): void {
    this.asset.viewMode = 'Repair';
    let repairDates = this.asset.RepairCampaigns.flatMap(x => x.Elements).map(y => new Date(new Date(y.properties.General.Collection.Date).toDateString()))
    repairDates = repairDates.sort()
    let structureDates = this.asset.StructureCampaigns.flatMap(x => x.Elements).map(y => new Date(new Date(y.properties.General.Collection.Date).toDateString()))
    structureDates = structureDates.sort()

    // this.graphicsMaterials.setStructureMaterialsVisibilityRepair(false);
    this.asset.RepairCampaigns.forEach(repairsCampaig => {
      repairsCampaig.Elements.forEach(element => {
        let date = new Date(new Date(element.properties.General.Collection.Date).toDateString())
        if (date > structureDates[0]) {
          if ((element as StructuralElement).isExecuted)
            element.defaultMaterial = GraphicsMaterials.repairBasicMaterial;
        } else {
          if ((element as StructuralElement).isExecuted)
            element.defaultMaterial = GraphicsMaterials.repairBasicMaterial;
        }
      });
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.Elements.forEach(element => {
        let dateStructure = new Date(new Date(element.properties.General.Collection.Date).toDateString())
        if (dateStructure > structureDates[0]) {
          if ((element as StructuralElement).isExecuted)
            element.defaultMaterial = GraphicsMaterials.repairBasicMaterial;
        } else {
          //element.SurfaceDesign.visible = false
        }
      });
    });
    this.asset.InspectionCampaigns.forEach(inspectionCampaig => {
      inspectionCampaig.group.visible = false;
    });
    this.graphicsMaterials.setStructureMaterialsVisibilityRepair(false);
  }

  public updateViewMode(viewMode: string = null) {
    if(viewMode){
      this.asset.viewMode = viewMode;
    }
    switch (this.asset.viewMode) {
      case 'Degradation':
        this.changeToDegradationViewMode();
        break;
      case 'RemainingLife':
        this.changeToRemainingLifeViewMode();
        break;
      case 'CorrosionRate':
        this.changeToCorrosionRateViewMode();
        break;
      case 'CorrosionRiskIndex':
        this.changeToCorrosionRiskIndexViewMode();
        break;
      case 'Risk':
        this.updateRiskViewMode();
        break;
      case 'StructuralLabel':
        this.changeToStructuralLabelViewMode();
        break;
      case 'LoadCycleClassification':
        this.changeToLoadCycleClassificationViewMode();
        break;
      default:
        break;
    }
  }

  public changeToXRaySensorViewMode(): void {
    this.asset.viewMode = 'Sensor';
    this.asset.InspectionCampaigns.forEach(inspectionCampaig => {
      inspectionCampaig.group.visible = false;
    });
    this.asset.RepairCampaigns.forEach(repairCampaign => {
      repairCampaign.group.visible = false;
    });
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.changeStructureMaterials(GraphicsMaterials.basicPhysicalMaterial);
    });
    this.graphicsMaterials.setStructureMaterialsOpacity(0.25);
    this.asset.SensorCampaign.changeSensorMaterials(GraphicsMaterials.sensorXrayMaterial);
    this.asset.SensorCampaign.group.visible = true;

  }

  public async changeToDegradationViewMode(): Promise<void> {
    const visibleRegions = this.asset.GetStructureVisibleRegions();
    const regionIds = visibleRegions.map(region => region.Guid);
    
    const waitPromises = regionIds.map(regionId =>
      this.degradationParametersLoader.waitUntilReady(regionId)
    );
    await Promise.all(waitPromises);
    
    this.asset.viewMode = 'Degradation';
    
    this.graphicsMaterials.setStructureMaterialsVisibility(false);

    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.updateDegradationColors(this.structureDegradationParametersList);
    });
    this.asset.RepairCampaigns.forEach(structureCampaig => {
      structureCampaig.updateDegradationColors(this.structureDegradationParametersList);
    });

    
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(visibleRegions);
    this.graphicsMaterials.degradationViewMode(visibleRegions);
  }

  public changeToRiskViewMode(): void {
    this.asset.viewMode = 'Risk';
    if (this._riskLevelsLoaded) {
      this.updateRiskViewMode()
      return
    }
    this.loadLightModelRiskLevels().then((applied) => {
      if (applied && this.asset.viewMode == "Risk") {
        this.updateRiskViewMode()
      }
    })
  }

  public updateRiskViewMode(): void {
    this.asset.StructureCampaigns.forEach(c => {
      c.resetMaterials()
    })
    if (this.regionsRiskLevels?.length > 0) {
        GraphicsMaterials.riskViewMode(this.asset?.lightCampaign?.regionsWorkableElements ?? [], this.regionsRiskLevels, this.riskLevels)

      if (this.asset.mode != "SECTIONS") {
        this.asset.StructureCampaigns.forEach(c => {
          GraphicsMaterials.riskViewMode(c.regionsWorkableElements.filter(x => x.visible), this.regionsRiskLevels, this.riskLevels)
        })
      }
      else {

      }

      // Apply vertex colors to lightSection merged meshes
      const lightRegions = this.asset?.lightCampaign?.regionsWorkableElements ?? [];
      this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(lightRegions);

      this.asset.CriticalAreaCampaigns.forEach(c => {
        GraphicsMaterials.updateCriticalAreaRiskMaterial((c.Elements as CriticalAreaElement[]), this.regionsRiskLevels, this.riskLevels)
      })

      if (this.asset.mode != "MODEL") {
        this.showAllCriticalAreas()
      }
      this.graphicsMaterials.generateRiskLegend(this.regionsRiskLevels, this.riskLevels);
    }
  }

  public invalidateRiskLevelsCache(): void {
    this._riskLevelsLoaded = false;
    this._riskLevelsLoadSeq++;
  }

  /** A critical area was saved/deleted on the backend: drop the cached risk levels and repaint if Risk is shown. */
  private onCriticalAreasChanged(): void {
    this.invalidateRiskLevelsCache();
    if (this.asset?.viewMode == 'Risk') {
      this.changeToRiskViewMode();
    }
  }

  public async changeToRemainingLifeViewMode(): Promise<void> {
    const visibleRegions = this.asset.GetStructureVisibleRegions();
    const regionIds = visibleRegions.map(region => region.Guid);
    
    const waitPromises = regionIds.map(regionId =>
      this.degradationParametersLoader.waitUntilReady(regionId)
    );
    await Promise.all(waitPromises);

    this.asset.viewMode = 'RemainingLife';
    this.graphicsMaterials.setStructureMaterialsVisibility(false);

    const high = 25
    const low = 5

    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.updateRemainingLifeViewMode(low, high, this.structureDegradationParametersList);
    });
    this.asset.RepairCampaigns.forEach(structureCampaig => {
      structureCampaig.updateRemainingLifeViewMode(low, high, this.structureDegradationParametersList);
    });
    
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(visibleRegions);
    this.graphicsMaterials.remainingLifeViewMode(visibleRegions);
  }

  public async changeToCorrosionRateViewMode(): Promise<void> {
    const visibleRegions = this.asset.GetStructureVisibleRegions();
    const regionIds = visibleRegions.map(region => region.Guid);
    
    const waitPromises = regionIds.map(regionId =>
      this.degradationParametersLoader.waitUntilReady(regionId)
    );
    await Promise.all(waitPromises);

    this.asset.viewMode = 'CorrosionRate';
    this.graphicsMaterials.setStructureMaterialsVisibility(false);

    const high = 0.6
    const low = 0.2

    //console.log("\nchangeToCorrosionRateViewMode Start: ", new Date().toJSON())
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.updateCorrosionRateViewMode(low, high, this.structureDegradationParametersList);
    });
    this.asset.RepairCampaigns.forEach(structureCampaig => {
      structureCampaig.updateCorrosionRateViewMode(low, high, this.structureDegradationParametersList);
    });
    
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(visibleRegions);
    this.graphicsMaterials.corrosionRateViewMode(visibleRegions);
  }

  public async changeToCorrosionRiskIndexViewMode(): Promise<void> {
    const visibleRegions = this.asset.GetStructureVisibleRegions();
    const regionIds = visibleRegions.map(region => region.Guid);
    
    const waitPromises = regionIds.map(regionId =>
      this.degradationParametersLoader.waitUntilReady(regionId)
    );
    await Promise.all(waitPromises);

    this.asset.viewMode = 'CorrosionRiskIndex';
    this.graphicsMaterials.setStructureMaterialsVisibility(false);

    const high = 20
    const low = 15

    let startAt = new Date()
    //console.log("\nchangeToCorrosionRiskIndexViewMode Start: ", startAt.toJSON())
    this.asset.StructureCampaigns.forEach(structureCampaig => {
      structureCampaig.updateCorrosionRiskIndexViewMode(low, high, this.structureDegradationParametersList);
    });
    this.asset.RepairCampaigns.forEach(structureCampaig => {
      structureCampaig.updateCorrosionRiskIndexViewMode(low, high, this.structureDegradationParametersList);
    });
    let endAt = new Date()
    //console.log("changeToCorrosionRiskIndexViewMode End: ", endAt.toJSON())

    const time = moment(endAt).diff(startAt)
    //console.log("duration Time: ", time, "milliseconds")
    
    this.graphicsMaterials.applyCurrentMaterialColorsToLightSection(visibleRegions);
    this.graphicsMaterials.corrosionRiskIndexViewMode(visibleRegions);
  }

  public async getLastAssetDocument(): Promise<void> {
    const documents = await this.documentsListService.getAssetDocuments(this.asset.assetInfo.AssetId);
    if (documents) {
      if (!this.asset.DocumentCollection.isVisible) {
        this.asset.changeDocumentsVisibility()
      }
      if (documents.length == 1) {
        this.graphicsRenderDocuments.populateDocumentCollection(this.asset, documents);
      }
      else this.graphicsRenderDocuments.populateDocumentCollection(this.asset, [documents[documents.length - 1]]);

      this.asset.changeDocumentsVisibilityMode();
    }
  }

  public async getAssetDocuments(): Promise<void> {
    const documents = await this.documentsListService.getAssetDocuments(this.asset.assetInfo.AssetId);
    if (documents) this.graphicsRenderDocuments.populateDocumentCollection(this.asset, documents);
  }

  public changeDocumentsVisibility(): void {
    this.asset.changeDocumentsVisibility();
  }

  public getElementById(elementId: string): WorkableElement {
    var element;
    this.asset.StructureCampaigns.forEach(structureCampaign => {
      var i = structureCampaign.SurfaceElements.findIndex(x => x.Guid === elementId);
      if (i >= 0) {
        element = structureCampaign.SurfaceElements[i];
      }
    });
    return element;
  }

  //#endregion

  //#region Insertion Methods

  public setFunctionalityModeNone(): void {
    if (this.functionalityMode === 'MERGEPLATE' && this.isMergePlateInProgress) {
      return;
    }

    this.functionalityMode = 'NONE';
    this.graphics.Controls.enableRotate = true;
    this._collectionComponentEnableCurrentType = false;
    this.isAreaInsertion = false;
    // A pinned pivot outline must never survive leaving insertion mode.
    this.graphics.clearPinnedSecondaryOutline();
    this.graphics.hammerManager.get('pan')?.set({ enable: false });
  }

  public FinishZoom(): void {
    this.functionalityMode = 'NONE'
    this.graphics.Controls.enableRotate = true;
    this.graphics.rectd.startRectangleSelection = false;
    this.graphics.hammerManager.get('pan').set({ enable: false });
    (document.querySelector(".custom-main") as any).style.cursor = "default"
  }

  public _CreateCollectionInfo(pDate: Date, pTypeId: any, CurrentMethodId?: string,
    CurrentInspectionTypeId?: string, InpectionTypeName?: string): CollectionInfoModel {
    const newCollection: CollectionInfoModel = {
      AssetId: this.asset.assetInfo.AssetId,
      Type: pTypeId,
      StatusId: CollectionStaticData.COLLECTION_STATUS_INIT_ID,
      Date: pDate,
      Label: InpectionTypeName,
      CollectionId: null,
      TempCollectionId: uuid() as string,
      CurrentMethodId: CurrentMethodId,
      IsVisible: true,
      IsFinished: false,
      CurrentInspectionTypeId: CurrentInspectionTypeId,
      BlobPaths: Array<CollectionBlobInfoModel>(),
    };
    return newCollection;
  }

  public AddCollectionIntegration(pDate: Date, pNewCollection: any, pTypeId: any, CurrentMethodId?: string,
    CurrentInspectionTypeId?: string, InpectionTypeName?: string, showMessage?: boolean): any {
    const newCollection: CollectionInfoModel = this._CreateCollectionInfo(pDate, pTypeId, CurrentMethodId,
      CurrentInspectionTypeId, InpectionTypeName);
    // pNewCollection.CollectionInfoModel = newCollection;
    this.collectionService.addCollection(newCollection, showMessage ?? true);

    return newCollection;
  }

  public async setDownloadedInspectionCollection(_collection: any, disposePoint: boolean, forceLoad: boolean) {
    await this.assetManagerDownloadedInspection.loadInspectionElements(this.asset, _collection.ResultList[0].ElementsResult, this.currentRegion.Guid, disposePoint, forceLoad, this.referenceDate, _collection.ChangeInspectionVisibility)
    this.updateAllInspectionColor();
    this.graphics.requestRender();
  }

  public setCurrentTypeCrud;

  public setCurrentType() {
    const inspectionType = {
      inspectioType: this.listInpectionType.find(x => x.id === '7188d6f6-afcd-4fea-a933-fa08f22cb2ae'),
      inspectionMethod: {
        id: INSERTIONCONSTANTS.ELEMENT,
        listAssociate: [],
        listRows: [],
        measurements: [],
        name: "Element",
      }
    };

    this.setCurrentTypeCrud(inspectionType);
  }

  public _setSelectedInspectionElement(gaugingElement: GaugingElement): void {
    this.collectionService.changeSelectElement(gaugingElement);
  }

  //#endregion


  //#region Reference date
  public async reapplyCurrentViewMode(): Promise<void> {
    switch (this.asset.viewMode) {
      case 'CorrosionRate':
        await this.changeToCorrosionRateViewMode();
        break;
      case 'CorrosionRiskIndex':
        await this.changeToCorrosionRiskIndexViewMode();
        break;
      case 'Degradation':
        await this.changeToDegradationViewMode();
        break;
      case 'RemainingLife':
        await this.changeToRemainingLifeViewMode();
        break;
      case 'Risk':
        this.changeToRiskViewMode();
        break;
      case 'ThicknessColor':
        this.changeToThicknessTableViewMode();
        break;
      case 'MaterialColor':
        this.changeToMaterialsViewMode();
        break;
      case 'RegionColor':
        this.changeToRegionsViewMode();
        break;
      case 'Structure4D':
        this.changeToStructure4DViewMode();
        break;
      case 'Inspection':
        this.changeToInspectionViewMode();
        break;
      case 'Repair':
        this.changeToXRayRepairViewMode();
        break;
      case 'Sensor':
        this.changeToXRaySensorViewMode();
        break;
      case 'Transparent':
        this.changeToTransparenceViewMode();
        break;
      case 'ReferenceElement':
        await this.changeToReferenceElementViewMode();
        break;
      case 'StructuralLabel':
        this.changeToStructuralLabelViewMode();
        break;
      case 'FEAResults':
      case 'PlatePanels':
      case 'StiffenedPanels':
      case 'LargePanels':
        break; // do nothing. but do NOT go to default
      default:
        // For unknown view modes, just ensure default visibility
        this.changeToDefaultViewMode();
        break;
    }
  }

  public async ChangeReferenceDate(date: Date) {
    const previousDate = this.referenceDate;
    date.setHours(0, 0, 0, 0);
    this.referenceDate = date;
    
    if (this.asset.viewMode && this.asset.viewMode !== 'DEFAULT') {
      this.reapplyCurrentViewMode();
    }

    // Emit reference date change event
    this.referenceDateEventsService.emitReferenceDateChange(previousDate, date);

    if (this.degradationMode) {
      this.updateAllDegradationParameters()
    }

    this.asset.StructureCampaigns.forEach((structure) => {
      structure.Elements.forEach((structureElement) => {
        if (structureElement.properties) {
          let formattedDate = new Date(new Date(structureElement.properties.General.Collection.Date).toDateString())
          if (this.currentRegion.Guid === structureElement.regionId) {
            if (
              formattedDate <= this.referenceDate
            ) {
              structureElement.SurfaceDesign.visible = true;
              if (structureElement instanceof StructuralElement && (structureElement as StructuralElement).Geometries) {
                var sortedList = (structureElement as StructuralElement).Geometries.sort((a, b) => {
                  return new Date(a.date).getTime() - new Date(b.date).getTime();
                });

                let geometryApplied = false;
                for (let i = sortedList.length - 1; i >= 0; i--) {
                  let fDate = new Date(new Date(sortedList[i].date).toDateString())
                  if (fDate <= this.referenceDate) {
                    if (!sortedList[i].geometryModel.GeometryV) continue;
                    let targetGeometry = new THREE.BufferGeometry();
                    targetGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(sortedList[i].geometryModel.GeometryV), 3));
                    if (sortedList[i].geometryModel.GeometryF && sortedList[i].geometryModel.GeometryF.length > 0)
                      targetGeometry.setIndex(sortedList[i].geometryModel.GeometryF);
                    targetGeometry.computeVertexNormals();

                    targetGeometry = mergeVertices(targetGeometry);

                    targetGeometry.computeBoundingBox();
                    targetGeometry.computeVertexNormals();

                    structureElement.SurfaceDesign.geometry = targetGeometry;
                    (structureElement as StructuralElement).clearBorder();
                    (structureElement as StructuralElement).createBorder(GraphicsMaterials.borderMaterialLineBasic);
                    geometryApplied = true;
                    break;
                  }
                }
                if (!geometryApplied && (structureElement as StructuralElement).originalGeometry) {
                  structureElement.SurfaceDesign.geometry = (structureElement as StructuralElement).originalGeometry.clone();
                  (structureElement as StructuralElement).clearBorder();
                  (structureElement as StructuralElement).createBorder(GraphicsMaterials.borderMaterialLineBasic);
                }
              }
            } else {
              structureElement.SurfaceDesign.visible = false
            }
          }
        }
      })
    })
    const refDateUTC = new Date(Date.UTC(this.referenceDate.getFullYear(), this.referenceDate.getMonth(), this.referenceDate.getDate()));
    this.asset.RepairCampaigns.forEach((repairCampaign) => {
      repairCampaign.Elements.forEach((repairStructureElement) => {
        if (repairStructureElement.properties) {
          const rawRepairDate = new Date(repairStructureElement.properties.General.Collection.Date);
          const repairDateUTC = new Date(Date.UTC(rawRepairDate.getUTCFullYear(), rawRepairDate.getUTCMonth(), rawRepairDate.getUTCDate()));
          if (this.currentRegion.Guid === repairStructureElement.regionId) {
            if (repairDateUTC <= refDateUTC) {
              repairStructureElement.SurfaceDesign.visible = true
            } else {
              repairStructureElement.SurfaceDesign.visible = false
            }
          }
        }
      })
    })

    if (this.asset.ProtectionElementsCollection?.Elements) {
      //let formattedDate = new Date(new Date(this.asset.ProtectionElementsCollection.Date).toDateString())
      this.asset.ProtectionElementsCollection.regionsWorkableElements.forEach((region) => {
        if (this.currentRegion.Guid === region.Guid) {
          region.sections.forEach((section) => {
            section.surfaceElements.forEach((surface) => {
              let formattedDate = new Date(surface?.createdAt);
              formattedDate.setHours(0, 0, 0, 0);
              if (formattedDate <= this.referenceDate) {
                surface.SurfaceDesign.visible = true
              } else {
                surface.SurfaceDesign.visible = false
              }
            }
            )
          })
        }
      })
    }

    this.updateAllInspectionColor()

    this.asset.CriticalAreaCampaigns.forEach((criticalAreaCollection) => {
      criticalAreaCollection.Elements.forEach((element) => {
        const criticalAreaElement = element as CriticalAreaElement
        let formattedDate = new Date(new Date(criticalAreaElement.CriticalAreaProperties.DateStarted).toDateString())
        let formattedDateEnded = new Date(new Date(criticalAreaElement.CriticalAreaProperties.DateEnded).toDateString())
        let c = new Date(new Date("1/1/0001 12:00:00").toDateString())
        var n = new Date();
        if (this.currentRegionsIds.includes(criticalAreaElement.regionId)) {
          if ((formattedDate <= this.referenceDate)) {
            if (formattedDateEnded.toDateString() === c.toDateString())
              criticalAreaElement.SurfaceDesign.visible = true
            else if (formattedDateEnded > this.referenceDate) {
              criticalAreaElement.SurfaceDesign.visible = true
            }
            else {
              criticalAreaElement.SurfaceDesign.visible = false
            }
          } else {
            criticalAreaElement.SurfaceDesign.visible = false
          }
        }
      })
    })

    this.hideAllInspections()

    this.updatePlansVisibilityBasedOnReferenceDate(this.plans)
  }

  public async estimateDegradationByCurveParameters() {
    this.inspectionElementsDegradationCurveParameters = []

    let assetId = this.asset.assetInfo.AssetId;
    let regionIds = this.asset.GetStructureVisibleRegions().map(x => x.Guid);

    this.noticationService.addInProgressNotification("Calculation of Degradation parameters")
    this.digitalTwinService.getAllDegradationCurveParameters(assetId, regionIds, this.referenceDate).subscribe((result: DegradationCurveParameters[]) => {
      this.inspectionElementsDegradationCurveParameters = result

      this.updateAllInspectionColor()

      this.noticationService.addLoadedNotification("Degradation")
    },
      error => {
        this.noticationService.addFailedNotification("Degradation")
        console.log(error)
      })
  }

  public estimateElementDegradationCurve(elementId: string, parentGeometryId: string, shouldCheckForExcessiveCorrosion: boolean = false) {
    if (window.navigator.onLine) {
      const inspectionElement = this.asset.InspectionCampaigns?.[0]?.Elements?.find(e => e.Guid == elementId) as GaugingElement
      if (inspectionElement && !this.shouldEstimateDegradationCurve(inspectionElement)) {
        return
      }

      const assetId = this.asset.assetInfo.AssetId;
      const regionIds = this.asset.GetStructureVisibleRegions().map(x => x.Guid);

      this.digitalTwinService.getDegradationCurveParameters(assetId, regionIds, elementId, parentGeometryId, this.referenceDate).subscribe((result: DegradationCurveParameters) => {
        if (!result) {
          return
        }

        this.applyInspectionDegradationCurveResult(result)
        this.noticationService.addUpdatedNotification("Degradation Curve")

        this.updateInspectionColorById(result.InspectionElementId)

        if (shouldCheckForExcessiveCorrosion) {
          const inspectionElement = this.asset.InspectionCampaigns[0].Elements.find(e => e.Guid == result.InspectionElementId) as GaugingElement
          this.excessiveCorrosionCheckRequested.next(inspectionElement)
        }
      },
        (error) => {
          this.noticationService.addFailedNotification("Degradation Curve update")
        })
    }
    else {
      if (this.degradationMode) {
        this.toggleDegradationMode()
      }
    }
  }

  public updateAllDegradationParameters() {
    this.inspectionElementsDegradationCurveParameters = this.updateDegradationCurvesForReferenceDate(this.inspectionElementsDegradationCurveParameters)
  }

  public applyInspectionDegradationCurveResult(result: DegradationCurveParameters): void {
    if (!result?.InspectionElementId) {
      return
    }

    const updatedCurve = DegradationUtil.updateDegradationParameters(result, this.referenceDate)
    const inspectionElementId = this.normalizeGeometryId(updatedCurve.InspectionElementId)

    this.inspectionElementsDegradationCurveParameters = [
      ...this.inspectionElementsDegradationCurveParameters.filter(curve => this.normalizeGeometryId(curve.InspectionElementId) != inspectionElementId),
      updatedCurve
    ]

    this.updateViewMode()
  }

  public removeInspectionDegradationCurveParameters(inspectionId: string): void {
    if (!inspectionId) {
      return
    }

    const normalizedInspectionId = this.normalizeGeometryId(inspectionId)

    this.inspectionElementsDegradationCurveParameters = this.inspectionElementsDegradationCurveParameters.filter(
      curve => this.normalizeGeometryId(curve.InspectionElementId) != normalizedInspectionId,
    )

    this.updateInspectionColorById(inspectionId)
    this.updateViewMode()
  }

  /**
   * Bulk counterpart of removeInspectionDegradationCurveParameters.
   *
   * Assigning inspectionElementsDegradationCurveParameters re-derives the degradation parameters
   * of every structural and repair element, so removing curves one inspection at a time made a
   * bulk delete quadratic. Profiled on a real region: 5.5s+ of fully saturated main thread after
   * the BulkDelete response landed, 97% of it inside that setter. One filter, one assignment.
   *
   * Returns the dropped curves grouped by the inspection id they were asked for, so an optimistic
   * removal can be undone for the inspections the backend ends up refusing to delete.
   */
  public removeInspectionsDegradationCurveParameters(inspectionIds: string[]): Map<string, DegradationCurveParameters[]> {
    const removedByInspectionId = new Map<string, DegradationCurveParameters[]>()
    const inspectionIdByNormalizedId = new Map<string, string>()

    for (const inspectionId of inspectionIds ?? []) {
      if (!inspectionId) {
        continue
      }
      inspectionIdByNormalizedId.set(this.normalizeGeometryId(inspectionId), inspectionId)
      removedByInspectionId.set(inspectionId, [])
    }

    if (inspectionIdByNormalizedId.size === 0) {
      return removedByInspectionId
    }

    const remainingCurves: DegradationCurveParameters[] = []
    for (const curve of this._inspectionElementsDegradationCurveParameters) {
      const inspectionId = inspectionIdByNormalizedId.get(this.normalizeGeometryId(curve.InspectionElementId))
      if (inspectionId === undefined) {
        remainingCurves.push(curve)
      } else {
        removedByInspectionId.get(inspectionId).push(curve)
      }
    }

    this.inspectionElementsDegradationCurveParameters = remainingCurves

    this.updateViewMode()

    return removedByInspectionId
  }

  /**
   * Undo of removeInspectionsDegradationCurveParameters, in the same single-assignment shape: an
   * optimistic bulk delete puts every rolled back inspection back with one recompute.
   */
  public restoreInspectionsDegradationCurveParameters(curves: DegradationCurveParameters[]): void {
    if (!curves?.length) {
      return
    }

    this.inspectionElementsDegradationCurveParameters = [
      ...this._inspectionElementsDegradationCurveParameters,
      ...curves,
    ]

    this.updateViewMode()
  }

  private normalizeGeometryId(id: string): string {
    return id?.replace(/-/g, '')
  }

  private getDegradationRequestRegionIds(regionIds?: string[]): string[] {
    return regionIds?.length > 0 ? regionIds : this.asset.GetStructureVisibleRegions().map(x => x.Guid)
  }

  private getDegradationCurvesByGeometry(parentGeometryId: string): DegradationCurveParameters[] {
    return this.inspectionElementsDegradationCurveParameters.filter(c => this.normalizeGeometryId(c.ParentGeometryId) == parentGeometryId)
  }

  private updateDegradationCurvesForReferenceDate(curves: DegradationCurveParameters[]): DegradationCurveParameters[] {
    return (curves ?? [])
      .filter(curve => curve != null)
      .map(curve => DegradationUtil.updateDegradationParameters(curve, this.referenceDate))
  }

  private replaceDegradationCurvesForGeometry(parentGeometryId: string, updatedCurves: DegradationCurveParameters[]): void {
    this.inspectionElementsDegradationCurveParameters = [
      ...this.inspectionElementsDegradationCurveParameters.filter(c => this.normalizeGeometryId(c.ParentGeometryId) != parentGeometryId),
      ...updatedCurves
    ]
  }

  private getInspectionIdsFromDegradationCurves(curves: DegradationCurveParameters[]): string[] {
    const inspectionIds: string[] = []

    for (const curve of curves) {
      if (curve.InspectionElementId && !inspectionIds.includes(curve.InspectionElementId)) {
        inspectionIds.push(curve.InspectionElementId)
      }
    }

    return inspectionIds
  }

  private updateInspectionColorsByIds(inspectionIds: string[]): void {
    for (const inspectionId of inspectionIds) {
      this.updateInspectionColorById(inspectionId)
    }
  }

  private applyGeometryDegradationCurveResult(parentGeometryId: string, previousCurves: DegradationCurveParameters[], result: DegradationCurveParameters[]): void {
    const updatedCurves = this.updateDegradationCurvesForReferenceDate(result)

    this.replaceDegradationCurvesForGeometry(parentGeometryId, updatedCurves)
    this.updateInspectionColorsByIds(this.getInspectionIdsFromDegradationCurves(previousCurves.concat(updatedCurves)))
    this.updateViewMode()
  }

  public estimateDegradationCurvesByTarget(targetId: string, regionIds?: string[], sectionId?: string) {
    if (!targetId) {
      return
    }

    if (!window.navigator.onLine) {
      if (this.degradationMode) {
        this.toggleDegradationMode()
      }
      return
    }

    const assetId = this.asset.assetInfo.AssetId;
    const parentGeometryId = this.normalizeGeometryId(targetId)
    const requestRegionIds = this.getDegradationRequestRegionIds(regionIds)
    const previousCurves = this.getDegradationCurvesByGeometry(parentGeometryId)

    this.digitalTwinService.getDegradationCurveParametersForGeometry(
      assetId,
      parentGeometryId,
      requestRegionIds,
      this.referenceDate,
      [INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING],
      undefined,
      sectionId
    ).subscribe((result: DegradationCurveParameters[]) => {
      this.applyGeometryDegradationCurveResult(parentGeometryId, previousCurves, result)
      this.noticationService.addUpdatedNotification("Degradation Curve")
    },
      (error) => {
        this.noticationService.addFailedNotification("Degradation Curve update")
      })
  }
  //#endregion


  //#region
  public updateElementsCollectionId(collectionId: string, tempCollectionId: string): void {
    const inspectionCollection = this.asset.InspectionCampaigns.find(
      (x) => x.CollectionInfoModel.TempCollectionId === tempCollectionId,
    );
    if (!Util.isNullOrUndefined(inspectionCollection)) {
      inspectionCollection.CollectionInfoModel.CollectionId = collectionId;
      inspectionCollection.Guid = collectionId;
    }
  }

  public async deleteElement(elementProperty: WorkableElement) {
    this.assetService.resetAssetInCache(this.asset.assetInfo.AssetId);
    try {
      this.noticationService.addInProgressNotification('Deleting Element');
      for (const regionId of elementProperty.properties.RegionIds) {
        const fetchUpdateProperties = await this.digitalTwinService.updateProperties
        (null, regionId, this.asset.assetInfo.AssetId, true, false, null, null, null, null, true, elementProperty.properties.ElementId);
        await firstValueFrom(fetchUpdateProperties);
      }
      elementProperty.SurfaceDesign.parent.remove(elementProperty.SurfaceDesign);
      this.noticationService.addFinishedNotification('Deleting Element');
      this.assetService.resetAssetInCache(this.asset.assetInfo.AssetId)  ;
    } catch (error) {
      this.noticationService.addFailedNotification('Deleting Element');
    }
  }

  private cloneElementProperties(properties: any): any {
    return properties == null ? properties : JSON.parse(JSON.stringify(properties))
  }

  public async updateProperty(elementProperty: WorkableElement) {
    const assetId = this.asset.assetInfo.AssetId
    const propertiesSnapshot = this.cloneElementProperties(elementProperty.properties)
    const regionIdsSource: string[] = Array.isArray(propertiesSnapshot?.RegionIds)
      ? propertiesSnapshot.RegionIds as string[]
      : elementProperty.regionIds ?? (elementProperty.regionId ? [elementProperty.regionId] : [])
    const regionIds: string[] = Array.from(new Set<string>(regionIdsSource.filter(regionId => !!regionId)))
    const sectionId = propertiesSnapshot?.SectionId ?? elementProperty.SectionId
    const geometryId = elementProperty.Guid

    this.assetService.resetAssetInCache(assetId)

    for (const regionId of regionIds) {
      const propertiesForRegion = this.cloneElementProperties(propertiesSnapshot)
      propertiesForRegion.RegionId = regionId
      propertiesForRegion.RegionIds = regionIds

      const fetchUpdateProperties = await this.digitalTwinService.updateProperties(propertiesForRegion, regionId, assetId);
      await firstValueFrom(fetchUpdateProperties);

      this.noticationService.addFinishedNotification('Loading Properties')

    }

    for (const regionId of regionIds) {
      await this.assetService.updateAssetInfoCollectionsInCache(assetId, regionId)
    }

    await this.reloadProperties(regionIds)
    this.noticationService.addInProgressNotification("Element Degradation Curves Update")
    this.estimateDegradationCurvesByTarget(geometryId, regionIds, sectionId)
  }

  /**
   * Multi-selection save: persists the (already mutated) properties of every
   * element through UpdateElementPropertyList, then runs the same refresh
   * steps as updateProperty. One request is sent per region (mirroring
   * updateProperty's per-region loop): the deployed backend writes only the
   * region file named by the request's RegionId, so a plate shared by two
   * regions must be sent once per region or it lands in a single file — and
   * which one depended on the first element's RegionIds order, not on the
   * loaded region (bug: "saved only on region B while region A was selected").
   * A backend that fans each element out to every id in its RegionIds just
   * rewrites the same values on the extra calls.
   */
  public async updatePropertiesBatch(elements: WorkableElement[]): Promise<void> {
    if (!elements || elements.length === 0) return
    const assetId = this.asset.assetInfo.AssetId
    const batches = buildRegionBatches(elements, properties => this.cloneElementProperties(properties))
    const regionIds: string[] = batches.map(batch => batch.regionId)
    if (regionIds.length === 0) return

    this.assetService.resetAssetInCache(assetId)
    this.noticationService.addInProgressNotification(`Saving ${elements.length} elements`)

    // Previous single-request version: relied on a backend that fans the batch
    // out to every region in each element's RegionIds (not deployed on stage/prod).
    // const propertiesList = elements.map(element => {
    //   const snapshot = this.cloneElementProperties(element.properties)
    //   if (!Array.isArray(snapshot.RegionIds) || snapshot.RegionIds.length === 0) {
    //     snapshot.RegionIds = element.regionIds ?? (element.regionId ? [element.regionId] : [])
    //   }
    //   return snapshot
    // })
    // await this.digitalTwinService.updatePropertiesList(propertiesList, regionIds[0], assetId)
    for (const batch of batches) {
      await this.digitalTwinService.updatePropertiesList(batch.properties, batch.regionId, assetId)
    }
    this.noticationService.addFinishedNotification(`Saving ${elements.length} elements`)

    for (const regionId of regionIds) {
      await this.assetService.updateAssetInfoCollectionsInCache(assetId, regionId)
    }
    await this.reloadProperties(regionIds)

    this.noticationService.addInProgressNotification("Element Degradation Curves Update")
    for (const element of elements) {
      const elementRegionIds = Array.isArray(element.properties?.RegionIds) && element.properties.RegionIds.length > 0
        ? element.properties.RegionIds
        : (element.regionIds ?? (element.regionId ? [element.regionId] : []))
      this.estimateDegradationCurvesByTarget(element.Guid, elementRegionIds, element.properties?.SectionId ?? element.SectionId)
    }
  }

  public async updateGltfJonAndProperty(elementProperty: WorkableElement) {
    this.assetService.resetAssetInCache(this.asset.assetInfo.AssetId)

    for (const regionId of elementProperty.properties.RegionIds) {
      try {
        const fetchUpdateProperties = await this.digitalTwinService.updateProperties(
          elementProperty.properties,
          regionId,
          this.asset.assetInfo.AssetId,
          true
        );
        await firstValueFrom(fetchUpdateProperties);

        // 9. Change inspection scope
        let scope = '';
        switch (elementProperty.TypeId) {
          case ELEMENTSTYPESIDS.PLATE:
            scope = 'ONLY PLATE';
            break;
          case ELEMENTSTYPESIDS.STIFFENER:
          case ELEMENTSTYPESIDS.BRACKET:
            if (elementProperty.properties.Geometry.WebThickness > 0) {
              scope = 'ONLY WEB';
            } else if (elementProperty.properties.Geometry.FlangeThickness > 0) {
              scope = 'ONLY FLANGE';
            }
            break;
          case ELEMENTSTYPESIDS.FACEPLATE:
            scope = 'ONLY FACE PLATE';
            break;
          default:
            break;
        }

        const fetchData = await this.digitalTwinService.changeInspectionScope(
          this.asset.assetInfo.AssetId,
          elementProperty.Guid,
          scope
        );
        // Also convert the inspection-scope call to an async/await flow
        await firstValueFrom(fetchData);

        await new Promise(resolve => setTimeout(resolve, 2000));
        const asset = await this.assetService.getFromBackEnd(this.asset.assetInfo.AssetId);

        this.noticationService.addFinishedNotification('Updating Properties');

      } catch (error) {
        // If anything goes wrong in the above try block, we'll land here
        console.error('Error in updateGltfJonAndProperty for regionId ', regionId, error);
      }
    }
  }

  //#region Recompartment

  /** Emitted once per recompartment, after it finished (successfully or not). */
  public readonly recompartmentFinished$ = new Subject<RecompartmentFinishedEvent>()
  /** True while a recompartment request is running (the properties sideboard shows a busy state). */
  public recompartmentInProgress: boolean = false
  /** Regions whose GLTF could not be regenerated by the last recompartments (offered for "Regenerate 3D"). */
  public recompartmentGltfFailures: RecompartmentGltfFailure[] = []
  /** True while a "Regenerate 3D" request is running. */
  public regeneratingGltf: boolean = false

  /**
   * Moves a structural element to a new region (compartment) set: ThreeD rewrites
   * the per-region files and regenerates the GLTFs, Inspection reassigns the
   * inspections/anomalies, then the loaded scene is patched in memory (no reload).
   * `elementProperty.properties` must already carry the form edits (AssignData).
   * Resolves to true only when ThreeD moved the element; `recompartmentFinished$`
   * reports the outcome to the properties form and the template.
   */
  public async recompartmentElement(elementProperty: WorkableElement, newRegionIds: string[], changeType: boolean = false,
      newRegions: Array<{ id: string; name: string; description?: string }> = [],
      sectionId: string | null = null,
      newSections: Array<{ id: string; name: string; cloneFromSectionId: string | null }> = []): Promise<boolean> {
    let outcome = { ok: false, selectionDisposed: false }
    this.recompartmentInProgress = true
    try {
      outcome = await this.runRecompartment(elementProperty, newRegionIds, changeType, newRegions, sectionId, newSections)
    } finally {
      this.recompartmentInProgress = false
      this.recompartmentFinished$.next({ elementId: elementProperty?.Guid, ok: outcome.ok, selectionDisposed: outcome.selectionDisposed })
    }
    return outcome.ok
  }

  private async runRecompartment(elementProperty: WorkableElement, newRegionIds: string[], changeType: boolean,
      newRegions: Array<{ id: string; name: string; description?: string }>,
      sectionId: string | null,
      newSections: Array<{ id: string; name: string; cloneFromSectionId: string | null }>): Promise<{ ok: boolean; selectionDisposed: boolean }> {
    const assetId = this.asset.assetInfo.AssetId
    const properties = elementProperty.properties
    const oldRegionIds: string[] = Array.from(new Set<string>(
      (properties?.RegionIds ?? elementProperty.regionIds ?? (elementProperty.regionId ? [elementProperty.regionId] : [])).filter(r => !!r)
    ))
    const targetRegionIds: string[] = Array.from(new Set<string>((newRegionIds ?? []).filter(r => !!r)))
    if (targetRegionIds.length === 0 || targetRegionIds.length > 2) {
      this.noticationService.addFailedNotification('Invalid regions selection')
      return { ok: false, selectionDisposed: false }
    }
    const currentSectionId = properties?.SectionId ?? elementProperty.SectionId
    const targetSectionId = sectionId && sectionId !== currentSectionId ? sectionId : null
    const pendingSection = targetSectionId ? newSections?.find(s => s.id === targetSectionId) : null
    const targetSectionName = targetSectionId ? (this.getSectionName(targetSectionId) ?? pendingSection?.name ?? null) : null
    const elementId = properties?.ElementId ?? elementProperty.Guid

    this.noticationService.addInProgressNotification('Changing Regions')
    this.assetService.resetAssetInCache(assetId)

    const previousRegionId = properties?.RegionId
    if (properties) {
      properties.RegionIds = targetRegionIds
      properties.RegionId = targetRegionIds.includes(previousRegionId) ? previousRegionId : targetRegionIds[0]
    }

    let threeDResult: RecompartmentElementResult | null = null
    let threeDError: any = null
    try {
      threeDResult = await firstValueFrom(this.digitalTwinService.recompartmentElement({
        AssetId: assetId,
        ElementId: elementId,
        SectionId: currentSectionId,
        OldRegionIds: oldRegionIds,
        NewRegionIds: targetRegionIds,
        ElementProperty: properties,
        ChangeType: changeType,
        // The backend stores the Name as the region Description (decision D1), so no description is sent.
        // .map(r => ({ Id: r.id, Name: r.name, Description: r.description })),
        NewRegions: (newRegions ?? [])
          .filter(r => targetRegionIds.includes(r.id))
          .map(r => ({ Id: r.id, Name: r.name })),
        NewSectionId: targetSectionId,
        NewSections: pendingSection ? [{ Id: pendingSection.id, Name: pendingSection.name, CloneFromSectionId: pendingSection.cloneFromSectionId ?? currentSectionId }] : [],
      }))
    } catch (error) {
      console.error('recompartmentElement: ThreeD call failed', error)
      threeDError = error ?? {}
    }
    const regionNameOf = (id: string) => this.getRegionName(id) ?? newRegions?.find(r => r.id === id)?.name
    const result = describeRecompartmentResult(threeDResult, threeDError, regionNameOf)
    if (!result.ok) {
      // 409 (rejected before any write), 400 (exception during the move) or a
      // Success=false body: nothing to patch in the scene, restore the element.
      if (properties) {
        properties.RegionIds = oldRegionIds
        properties.RegionId = previousRegionId
      }
      // this.noticationService.addFailedNotification('Changing Regions')
      this.noticationService.addFailedNotification(result.failureMessage)
      return { ok: false, selectionDisposed: false }
    }

    try {
      const regionNames = targetRegionIds.map(id => this.getRegionName(id) ?? newRegions?.find(r => r.id === id)?.name ?? '')
      const updatedInspections = await firstValueFrom(this.digitalTwinService.recompartmentInspections(assetId, elementProperty.Guid, targetRegionIds, regionNames, targetSectionId, targetSectionName))
      this.applyRecompartmentedInspections(updatedInspections)
    } catch (error) {
      console.error('recompartmentElement: Inspection call failed', error)
      this.noticationService.addFailedNotification('Updating inspections regions')
    }

    if (changeType) {
      try {
        await firstValueFrom(await this.digitalTwinService.changeInspectionScope(assetId, elementProperty.Guid, this.inspectionScopeFor(elementProperty)))
      } catch (error) {
        console.error('recompartmentElement: changeInspectionScope failed', error)
      }
    }

    try {
      // Regions/sections are cached per asset; created or re-linked ones must be re-read.
      this.assetService.clearRegionsAndSectionsCache()
      this.asset.assetInfo = await this.assetService.getFromBackEnd(assetId)
    } catch (error) {
      console.error('recompartmentElement: could not refresh asset info', error)
    }

    const selectionDisposed = this.applyRecompartmentInScene(elementProperty.Guid, oldRegionIds, targetRegionIds, targetSectionId, targetSectionName)

    const touched = Array.from(new Set<string>([...oldRegionIds, ...targetRegionIds]))
    const loadedTouched = touched.filter(id => this.asset.StructureCampaigns?.[0]?.regionsWorkableElements.some(r => r.Guid === id))
    for (const regionId of loadedTouched) {
      try { await this.assetService.updateAssetInfoCollectionsInCache(assetId, regionId) } catch (error) { console.error(error) }
    }
    if (loadedTouched.length > 0) {
      await this.reloadProperties(loadedTouched)
    }
    this.estimateDegradationCurvesByTarget(elementProperty.Guid, targetRegionIds, targetSectionId ?? currentSectionId)
    this.noticationService.addFinishedNotification('Changing Regions')
    // The move succeeded but some 3D models could not be regenerated: warn last
    // (so the toast is visible) and keep them for the "Regenerate 3D" action.
    this.rememberGltfFailures(assetId, elementProperty.Guid, result.gltfFailures)
    for (const warning of result.warningMessages) {
      this.noticationService.addNotification('Changing Regions', warning)
    }
    return { ok: true, selectionDisposed }
  }

  /** Replaces the remembered GLTF failures of the touched regions with the latest result. */
  private rememberGltfFailures(assetId: string, elementId: string, failures: GltfRegionFailure[]): void {
    const failedIds = new Set(failures.map(f => f.regionId))
    this.recompartmentGltfFailures = [
      ...this.recompartmentGltfFailures.filter(f => f.assetId === assetId && !failedIds.has(f.regionId)),
      ...failures.map(f => ({ ...f, assetId, elementId })),
    ]
  }

  /**
   * GLTF failures relevant to an element: those reported by its own last move,
   * plus any failed region it belongs to (old or new region set).
   */
  public gltfFailuresForElement(elementId: string, regionIds: string[] = []): RecompartmentGltfFailure[] {
    const assetId = this.asset?.assetInfo?.AssetId
    if (!assetId || !elementId) return []
    return this.recompartmentGltfFailures.filter(f => f.assetId === assetId
      && (f.elementId === elementId || (regionIds ?? []).includes(f.regionId)))
  }

  /**
   * "Regenerate 3D": regenerates the GLTF of regions whose conversion failed
   * after a recompartment, then refreshes the asset info (same caches as the move).
   * Resolves to true when the backend regenerated every requested region.
   */
  public async regenerateRegionGltfs(regionIds: string[]): Promise<boolean> {
    const assetId = this.asset?.assetInfo?.AssetId
    const ids = Array.from(new Set((regionIds ?? []).filter(id => !!id)))
    if (!assetId || ids.length === 0 || this.regeneratingGltf) return false

    this.regeneratingGltf = true
    this.noticationService.addInProgressNotification('Regenerating 3D')
    let ok = false
    try {
      ok = (await firstValueFrom(this.digitalTwinService.generateGltf(assetId, ids))) !== false
    } catch (error) {
      console.error('regenerateRegionGltfs: GenerateGltf failed', error)
      ok = false
    }

    try {
      // Regenerated regions get new RenderGeoPaths; re-read them (even after a partial failure).
      this.assetService.resetAssetInCache(assetId)
      this.assetService.clearRegionsAndSectionsCache()
      this.asset.assetInfo = await this.assetService.getFromBackEnd(assetId)
      const loaded = ids.filter(id => this.asset.StructureCampaigns?.[0]?.regionsWorkableElements.some(r => r.Guid === id))
      for (const regionId of loaded) {
        try { await this.assetService.updateAssetInfoCollectionsInCache(assetId, regionId) } catch (error) { console.error(error) }
      }
    } catch (error) {
      console.error('regenerateRegionGltfs: could not refresh asset info', error)
    } finally {
      this.regeneratingGltf = false
    }

    if (ok) {
      this.recompartmentGltfFailures = this.recompartmentGltfFailures.filter(f => !(f.assetId === assetId && ids.includes(f.regionId)))
      this.noticationService.addFinishedNotification('Regenerating 3D')
    } else {
      this.noticationService.addFailedNotification('Regenerating 3D')
    }
    return ok
  }

  /**
   * The Inspection service re-links plans/clusters on the checklist items when
   * an element changes compartment; mirror those links onto the loaded
   * inspections so filters and the timeline agree with the database.
   */
  private applyRecompartmentedInspections(updated: any[]): void {
    if (!Array.isArray(updated) || updated.length === 0) return
    for (const campaign of this.asset.InspectionCampaigns ?? []) {
      for (const source of updated) {
        // A point loaded in two regions exists twice (one instance per region).
        const instances = (campaign.Elements ?? []).filter(e => e.Guid === source?.id) as GaugingElement[]
        for (const gauging of instances) {
          if (!applyInspectionLinks(gauging.elementResult, source)) continue
          gauging.regionIds = source.RegionIds ?? gauging.regionIds
          if (gauging.checkList !== gauging.elementResult?.CheckList) {
            applyInspectionLinks({ id: source.id, CheckList: gauging.checkList }, { id: source.id, CheckList: source.CheckList })
          }
        }
      }
    }
  }

  private inspectionScopeFor(elementProperty: WorkableElement): string {
    switch (elementProperty.TypeId) {
      case ELEMENTSTYPESIDS.PLATE: return 'ONLY PLATE'
      case ELEMENTSTYPESIDS.STIFFENER:
      case ELEMENTSTYPESIDS.BRACKET:
        if (elementProperty.properties?.Geometry?.WebThickness > 0) return 'ONLY WEB'
        if (elementProperty.properties?.Geometry?.FlangeThickness > 0) return 'ONLY FLANGE'
        return ''
      case ELEMENTSTYPESIDS.FACEPLATE: return 'ONLY FACE PLATE'
      default: return ''
    }
  }

  /**
   * Patches the loaded scene after a recompartment: instances in regions the
   * element left are re-homed into loaded regions it joined (or disposed),
   * loaded joined regions without an instance get a clone, and every surviving
   * instance plus its attached inspections carry the new region set.
   */
  public applyRecompartmentInScene(guid: string, oldRegionIds: string[], newRegionIds: string[],
      sectionId: string | null = null, sectionName: string | null = null): boolean {
    const structure = this.asset.StructureCampaigns?.[0]
    if (!structure) return false
    const loadedRegions = structure.regionsWorkableElements.map(r => r.Guid)
    const instanceOf = (regionId: string): WorkableElement => structure.getElementByIdOnly(regionId, guid)
    const regionsWithInstance = loadedRegions.filter(id => !!instanceOf(id))
    const actions = computeRecompartmentActions(regionsWithInstance, loadedRegions, oldRegionIds, newRegionIds)
    // The element leaves every loaded region: the caller closes its selection.
    const leavesScene = leavesLoadedScene(regionsWithInstance, actions)

    const regionOf = (regionId: string) => structure.regionsWorkableElements.find(r => r.Guid === regionId)
    // Make sure the target section exists in the region (with its proper name)
    // before attaching, so a new/other section gets a named shell in the tree.
    const ensureSection = (region: Region, targetSectionId: string) => {
      if (!targetSectionId || region.sections.some(s => s.Guid === targetSectionId)) return
      const section = new Section(targetSectionId, sectionName ?? this.getSectionName(targetSectionId) ?? targetSectionId)
      section.isStructureSection = true
      region.addSection(section)
    }
    const applySection = (element: WorkableElement) => {
      if (!sectionId) return
      element.SectionId = sectionId
      if (element.properties) {
        element.properties.SectionId = sectionId
        if (element.properties.General && 'SectionId' in element.properties.General) element.properties.General.SectionId = sectionId
      }
      if (element instanceof StructuralElement) {
        for (const gauging of element.gaugingElements) {
          gauging.SectionId = sectionId
          if (gauging.elementResult) gauging.elementResult.SectionId = sectionId
        }
      }
    }
    const attach = (element: WorkableElement, regionId: string) => {
      const region = regionOf(regionId)
      if (!region) return
      const fromRegionId = element.regionId
      element.regionId = regionId
      if (element.properties) element.properties.RegionId = regionId
      applySection(element)
      ensureSection(region, element.SectionId)
      if (element instanceof LinearElement) region.addLinearElement(element)
      else region.addSurfaceElement(element)
      element.Campaign = structure
      rehomePoints(element, fromRegionId, regionId)
    }
    // Point meshes live under the inspection campaign's own region/section groups,
    // so they must follow the element instance they are attached to.
    const rehomePoints = (element: WorkableElement, fromRegionId: string, toRegionId: string) => {
      if (!(element instanceof StructuralElement)) return
      for (const gauging of element.gaugingElements) {
        const campaign = gauging.Campaign ?? this.asset.InspectionCampaigns?.[0]
        if (!campaign) continue
        const detached = campaign.RegionById(fromRegionId)?.detachElementByIdOnly(gauging.Guid)
          ?? campaign.RegionById(gauging.regionId)?.detachElementByIdOnly(gauging.Guid)
        gauging.regionId = toRegionId
        gauging.regionName = this.getRegionName(toRegionId) ?? gauging.regionName
        if (detached) campaign.addSurfaceElement(gauging)
        // dev: an instanced POINT keeps its element's structure section (and batch).
        if (detached) rehomePointInstance(this.instanceManager, gauging, element.section)
      }
    }

    // Section change for instances that stay in their region: re-parent inside it.
    if (sectionId) {
      for (const regionId of loadedRegions) {
        const element = instanceOf(regionId)
        if (!element || element.SectionId === sectionId) continue
        if (!newRegionIds.includes(regionId)) continue
        const region = regionOf(regionId)
        const detached = region?.detachElementByIdOnly(guid)
        if (detached) attach(detached, regionId)
      }
    }

    let disposedSelected = false
    for (const move of actions.rehome) {
      const element = regionOf(move.from)?.detachElementByIdOnly(guid)
      if (element) attach(element, move.to)
    }
    for (const regionId of actions.dispose) {
      const element = instanceOf(regionId) as StructuralElement
      // Points are loaded per region: a surviving instance in another loaded
      // region already has its own copies, so this region's copies just go.
      const gaugings = element instanceof StructuralElement ? [...element.gaugingElements] : []
      for (const gauging of gaugings) {
        // dev: an instanced POINT has no mesh for deleteElementByIdOnly to remove; drop its slot.
        removePointInstance(this.instanceManager, gauging)
        this.asset.InspectionCampaigns?.forEach(campaign => campaign.deleteElementByIdOnly(regionId, gauging.Guid))
      }
      if (this.currentSelectedElement === element) disposedSelected = true
      if (element instanceof LinearElement) structure.deleteElementLinearElementByIdOnly(regionId, guid)
      else structure.deleteElementByIdOnly(regionId, guid)
    }

    for (const regionId of loadedRegions) {
      const element = instanceOf(regionId)
      if (!element) continue
      element.regionIds = newRegionIds
      if (element.properties) {
        element.properties.RegionIds = newRegionIds
        element.properties.RegionId = regionId
      }
      if (element instanceof StructuralElement) {
        for (const gauging of element.gaugingElements) {
          gauging.regionIds = newRegionIds
          if (gauging.elementResult) {
            gauging.elementResult.RegionIds = newRegionIds
            // Same rule as the Inspection service: the first region chosen in the form.
            gauging.elementResult.InsertedRegionId = newRegionIds[0]
          }
          if (!newRegionIds.includes(gauging.regionId)) gauging.regionId = regionId
        }
      }
    }

    if (disposedSelected) {
      this.currentSelectedElement = newRegionIds.map(id => instanceOf(id)).find(e => !!e) ?? null
    }
    this.updateViewMode()
    // dev renders on demand: the moved/disposed instances must trigger a frame.
    this.graphics.requestRender()
    return leavesScene
  }

  //#endregion

  //#region  Load Properties And Linear Elements

  async loadProperties(regionIds: any[], cleanProperties: boolean): Promise<void> {
    let currentAsset = await this.assetService.getCurrentAsset(this.asset.assetInfo.AssetId)
    this.asset.assetInfo = currentAsset.AssetInfo

    if (cleanProperties) {
      // delete this.graphics.propertiesNavigator.ElementProperties;
      // this.graphics.propertiesNavigator.ElementProperties = [];
    }

    for (const regionId of regionIds) {
      if (!this.asset.currentRegionsIds.includes(regionId)) {
        var region;

        if (this.asset.StructureCampaigns) {
          region = this.asset.StructureCampaigns[0].regionsWorkableElements
            .find(x => x.Guid === regionId);
        }
        else region = this.regionsService.getRegion(regionId);

        if (region && region.isPropertiesLoaded)
          return;

        this.currentRegionId = regionId;
        this.currentRegionsIds.push(regionId);
        //Get All Properties From section
        const propertiesPath = [];
        const linearElementsPath = [];
        const collectionsToLoad = [];
        for (const collection of this.asset.assetInfo.Collections) {
          const blobs = collection.BlobPaths.filter(x => x.RegionId === regionId);
          for (const blob of blobs) {
            if (!Util.isNullOrUndefined(blob.PropertiesPath)) {
              propertiesPath.push(blob.PropertiesPath);
            }
          }
          if (collection.Type === '27bc58e55d9f4326846796cfce711039' && collection.CurrentInspectionTypeId === INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING) {
            collectionsToLoad.push(collection.CollectionId);
          }
        }
        await this.digitalTwinService.loadProperties(this.asset, propertiesPath, regionId);
      }
    }

    return Promise.resolve();
  }

  async reloadProperties(regionIds: string[]) {
    this.assetService.resetAssetInCache(this.asset.assetInfo.AssetId)
    for (const regionId of regionIds) {
      var region;

      if (this.asset.StructureCampaigns) {
        region = this.asset.StructureCampaigns[0].regionsWorkableElements
          .find(x => x.Guid === regionId);
      }
      else region = this.regionsService.getRegion(regionId);

      if (region && region.isPropertiesLoaded) {
        region.isPropertiesLoaded = false
      }

    }
    return await this.loadProperties(regionIds, true)
  }
  //#endregion

  public homeView() {
    if (this.asset.mode === 'SECTIONS' && this.currentSection && this.currentSection.sectionNormal) {
      this.cameraControl.setcanonicalCameraForSection(this.asset.getVisibleBox(), this.currentSection.sectionNormal);
    }
    else {
      this.cameraControl.setCameraPosition(this.asset.getVisibleBox());
    }
  }

  public fitToScreen() {

    var pLocal = new THREE.Vector3(0, 0, -1);
    var pWorld = pLocal.applyMatrix4(this.graphics.camera.matrixWorld);
    var dir = pWorld.sub(this.graphics.camera.position).normalize();
    const box = this.asset.getVisibleBox();
    var v = box.getSize(new THREE.Vector3());
    var max = Math.max(v.x, v.y, v.z)
    this.cameraControl.zoomFitObject(box, dir, max * 1.5)

  }

  /**
   * Updates the scale of labels based on camera distance
   */
  public updateLabelScales(): void {
    // Update structure labels scales
    this.viewModeStructureLabelsService.updateLabelScales();
    
    // Note: Anomaly labels are updated directly by their service
    // to avoid circular dependency
  }

  /**
   * Called by Graphics to update label scales
   */
  public triggerLabelScaleUpdate(): void {
    this.updateLabelScales();
    // Note: Anomaly labels are self-updating to avoid circular dependency
  }

  public filterPointsWithoutMeasurementFromTempArray() {
    this.tempInsertedPointsArray = this.tempInsertedPointsArray.filter(p => !(p as GaugingElement).gaugingValue);
  }

  public deletePointFromTempArray(element) {
    let index: number = -1;
    if (element.Guid) {
      index = this.tempInsertedPointsArray.findIndex(x => x.Guid === element.Guid);
    }
    if (index !== -1) {
      this.tempInsertedPointsArray.splice(index, 1);
    }
  }

  public deletePointFromSelectedPointsArray(element) {
    let index: number = -1;
    if (element.id || element.Guid) {
      index = this.selectedInspections.findIndex(x => x.Guid === element.id || x.Guid === element.Guid);
    }
    if (index !== -1) {
      this.selectedInspections.splice(index, 1)
    }
  }

  public enableMultipleSelection() {
    this.functionalityMode = 'MULTIPLESELECTION';
    this.graphics.hammerManager.get('pan')?.set({ enable: true });
    this.graphics.Controls.enableRotate = false;

    // if there's new inserted points without measurement, select them automatically
    if (this.tempInsertedPointsArray.length > 0) {
      this.setNewInsertedPointsAsSelectedPoints();
    }
  }

  public setNewInsertedPointsAsSelectedPoints() {
    this.filterPointsWithoutMeasurementFromTempArray();
    this.selectedInspections = this.tempInsertedPointsArray.slice();
  }


  public showAllInspections() {
    this.asset.InspectionCampaigns.forEach((inspectionCollection) => {
      inspectionCollection.Elements.forEach((element) => {
        element.SurfaceDesign.visible = true
      })
    })
  }

  public async showAllSectionsInspectionsWhenInRepair() {

    let elements = this.asset.StructureCampaigns.flatMap(x => x.Elements.filter(y => y.realVisibility));

    let regionsIds = Array.from(new Set(elements.flatMap(x => x.regionIds)));
    let result = await this.inspectionService.getTargetsInspections(this.asset.assetInfo.AssetId, elements.map(x => x.Guid), this.referenceDate.toJSON(),
    regionsIds, this.currentSection.Guid).toPromise();
  }

  //#region Inspection Colors
  public showAllCriticalAreas() {
    this.asset.CriticalAreaCampaigns.forEach((c) => {
      c.Elements.forEach((element) => {
        element.SurfaceDesign.visible = true
      })
    })
  }

  public selectElement(){

  }

  //#region Inspection Colors
  public updateStructureElementColor(elementId: string, color: string | number) {
    this.asset.StructureCampaigns.forEach(structureCampaign => {
      var i = structureCampaign.SurfaceElements.findIndex(x => x.Guid === elementId);
      if (i >= 0) {
        structureCampaign.SurfaceElements[i].currentRenderMaterial = GraphicsMaterials.colorToBasicMaterial(color);
      }
    });
  }

  public updateStructureElementColorToDefault(elementId: string) {
    this.asset.StructureCampaigns.forEach(structureCampaign => {
      var i = structureCampaign.SurfaceElements.findIndex(x => x.Guid === elementId);
      if (i >= 0) {
        structureCampaign.SurfaceElements[i].currentRenderMaterial = structureCampaign.SurfaceElements[i].defaultMaterial;
      }
    });
  }

  public updateAllInspectionColor() {

    this.asset.InspectionCampaigns.forEach((inspectionCollection) => {
      inspectionCollection.Elements.forEach((element) => {
        this.updateInspectionColor(element)
      })
    })

    // MGR-03: After all per-element color updates have flowed through
    // PhantomSurfaceDesign.material setter -> instanceManager.setInstanceColor ->
    // _colorDirty set, flush all dirty buffers in one GPU upload.
    // The per-frame flush in graphics.ts renderAnimation also calls this, but
    // calling it here ensures an immediate visual update when the bulk loop finishes.
    this.instanceManager.flushDirtyBuffers();
  }

  private async reloadAnomaly(anomalyId: string):Promise<AnomalyModel[]>{
    return await this.anomalyService.getAnomalyListByIds([anomalyId]).toPromise();
  }

  public async reloadAnomalies():Promise<void>{
    if(this.currentRegion){
      var anomalies = await this.anomalyService.getAnomalyList(this.asset.assetInfo.AssetId, this.currentRegion.Guid);
      this.asset.anomalies = anomalies;
    }
  } 

  public updateInspectionColorById(inspectionId: string) {
    const inspection = this.asset.InspectionCampaigns[0].Elements.find(e => e.Guid == inspectionId)
    if (inspection) {
      this.updateInspectionColor(inspection)
    }
  }

  public updateInspectionColor(element: WorkableElement | GaugingElement) {
    const gaugingElement = element as GaugingElement
    // if(!gaugingElement.elementResult.Active){
    //   gaugingElement.SurfaceDesign.visible = false
    //   return;
    // }
    if (this.currentRegion.Guid === gaugingElement.regionId) {
      let alreadyExists = this.doesInspectionExistOnDate(gaugingElement)

      // if (alreadyExists) {
      let usePointMethod = false

      if (gaugingElement.elementResult.InspectionTypeId ==
        INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING) {
        usePointMethod = true;
      }
      else if ((gaugingElement.elementResult.CheckList as any[])
        .every(c => c.InputTypeId == "number")) {
        usePointMethod = true;
      }

      if (usePointMethod) {
        this.updateInspectionPointColor(gaugingElement)
      }
      else {
        this.updateInspectionAreaColor(gaugingElement)
      }
      // gaugingElement.SurfaceDesign.visible = true
      // }
      // else {
      //   // gaugingElement.SurfaceDesign.visible = false
      // }
    }
  }


  public updateInspectionPointColor(gaugingElement: GaugingElement) {
    // Skip orphan inspections - keep their special material
    if (gaugingElement.isOrphan) return;

    if (this.toInspectInCurrentPlan(gaugingElement)) {
      gaugingElement.defaultMaterial = SteelThicknessGaugingPoint.emptyValueMaterial
      return;
    }

    const curve: DegradationCurveParameters = this.inspectionElementsDegradationCurveParameters.find(p => p.InspectionElementId == gaugingElement.Guid)
    const hasOverThickness = DegradationUtil.isOverthickness(curve) || this.hasOverThicknessValue( gaugingElement, curve?.OriginalThickness)
    const hasValue = this.hasValue(gaugingElement)

    if (hasOverThickness){
      gaugingElement.defaultMaterial = GraphicsMaterials.pointMaterialBlack
    }
    else if (hasValue && curve && curve.CorrosionRate != 0) {
      if (gaugingElement instanceof SteelThicknessGaugingPoint) {
        (gaugingElement as SteelThicknessGaugingPoint).gaugingValue = curve.EstimatedThickness
      }
      // else {
        this.setInspectionPointColor(gaugingElement, curve.EstimatedThickness)
      // }
    }
    else {
      if (gaugingElement instanceof SteelThicknessGaugingPoint) {
        (gaugingElement as SteelThicknessGaugingPoint).updateMaterial(this.referenceDate)
      }
      // else {
        this.setInspectionPointColor(gaugingElement)
      // }
    }
  }

  public updateInspectionAreaColor(gaugingElement: GaugingElement) {
    // Skip orphan inspections - keep their special material
    if (gaugingElement.isOrphan) return;

    if (!window.navigator.onLine)
      gaugingElement.defaultMaterial = GraphicsMaterials.redInspectionMaterial

    var plansAndClusters = this.getPlansAndClusters()

    var currentInspectionPlans = this.selectCurrentPlansAndClusters(gaugingElement, plansAndClusters);

    const hasChecklistDateInCurrentPlan = this.hasChecklistDateInCurrentPlan(gaugingElement, currentInspectionPlans);

    let plansToConsider = currentInspectionPlans;
    let hasChecklistDate = hasChecklistDateInCurrentPlan;
    
    if (!hasChecklistDateInCurrentPlan) {
      const previousPlans = this.selectPreviousPlansAndClusters(gaugingElement, plansAndClusters);
      if (previousPlans.length > 0) {
        plansToConsider = previousPlans;
        hasChecklistDate = this.hasChecklistDateInCurrentPlan(gaugingElement, previousPlans);
      }
    }

    const relevantChecklists = this.getRelevantChecklists(gaugingElement, plansToConsider, hasChecklistDate);

    const activeAnomalies = this.getActiveAnomaliesInCurrentPlanOrLater(gaugingElement, plansToConsider);

    const anomaliesNotYetInTimeCompleted = this.getAnomaliesNotYetCompletedFromReferenceDate(gaugingElement, currentInspectionPlans);

    const hasResolvedValue = this.hasResolvedValueInRelevantChecklists(gaugingElement, relevantChecklists, plansToConsider);

    if(hasChecklistDateInCurrentPlan) {
      if(hasResolvedValue) {
        this.setMaterial(gaugingElement, GraphicsMaterials.greenInspectionMaterial);
        return;
      }

      const hasAnyValueInRelevantChecklists = relevantChecklists.some(c => this.hasChecklistItemMeaningfulData(c));
      if (!hasAnyValueInRelevantChecklists) {
        this.setMaterial(gaugingElement, GraphicsMaterials.inspectionMaterial);
        return;
      }
      
      // if (activeAnomalies.length > 0) {
      //   this.setMaterial(gaugingElement, GraphicsMaterials.yellowInspectionMaterial);
      //   return;
      // }

      // this.setMaterial(gaugingElement, GraphicsMaterials.inspectionMaterial);
      // return;
    }

    if (activeAnomalies.length > 0 || (anomaliesNotYetInTimeCompleted.length > 0 && !hasResolvedValue)) {
      this.setMaterial(gaugingElement, GraphicsMaterials.yellowInspectionMaterial);
      return;
    }

    if (hasResolvedValue) {
      this.setMaterial(gaugingElement, GraphicsMaterials.greenInspectionMaterial);
      return;
    }

    this.setMaterial(gaugingElement, GraphicsMaterials.inspectionMaterial);
  }

  private setMaterial(gaugingElement: GaugingElement, material: any) {
    gaugingElement.defaultMaterial = material;
    gaugingElement.SurfaceDesign.material = material;
    gaugingElement.currentMaterial = material;
    if (material !== GraphicsMaterials.inspectionMaterial) {
      gaugingElement = this.setUvsValuesToAnomalies(gaugingElement);
    }
  }

  private selectPreviousPlansAndClusters(gaugingElement: GaugingElement, plansAndClusters: Partial<IInspectionPlan>[]): Partial<IInspectionPlan>[] {
    if (!plansAndClusters || !plansAndClusters.length) {
      return [];
    }

    var inspectionPlans = plansAndClusters.filter(p => p.inspectionTypeId == gaugingElement.elementResult.InspectionTypeId)
    if (!inspectionPlans || !inspectionPlans.length) {
      return [];
    }

    let referenceDate = new Date(this.referenceDate);
    referenceDate.setHours(0, 0, 0, 0);

    let latestChecklistDate: Date | null = null;
    let latestChecklistDatePlan: Partial<IInspectionPlan> | null = null;

    const checklistDatesBeforeReference = gaugingElement.elementResult.CheckList
      .filter(c => c.Date && this.hasChecklistItemMeaningfulData(c))
      .map(c => {
        const checkListDate = new Date(c.Date);
        checkListDate.setHours(0, 0, 0, 0);
        return checkListDate;
      })
      .filter(date => date < referenceDate)
      .sort((a, b) => b.getTime() - a.getTime());

    if (checklistDatesBeforeReference.length === 0) {
      return [];
    }

    latestChecklistDate = checklistDatesBeforeReference[0];

    for (const plan of inspectionPlans) {
      const startDate = new Date(plan.assetWindowStartsAt.toString() + (plan.assetWindowStartsAt.toString().includes('Z') ? '' : 'Z'));
      const endDate = new Date(plan.assetWindowEndsAt.toString() + (plan.assetWindowEndsAt.toString().includes('Z') ? '' : 'Z'));
      startDate.setUTCHours(0, 0, 0, 0);
      endDate.setUTCHours(23, 59, 59, 999);

      if (latestChecklistDate >= startDate && latestChecklistDate <= endDate) {
        latestChecklistDatePlan = plan;
        break;
      }
    }

    return latestChecklistDatePlan ? [latestChecklistDatePlan] : [];
  }

  private hasChecklistItemMeaningfulData(checklistItem: ChecklistItem): boolean {
    if (checklistItem.Value && checklistItem.Value.trim() !== '') {
      return true;
    }

    if (checklistItem.AttributesList?.length > 0) {
      for (const attributeCategory of checklistItem.AttributesList) {
        if (attributeCategory.attributeScoreInfo) {
          for (const scoreInfo of attributeCategory.attributeScoreInfo) {
            if (scoreInfo.selected) {
              return true;
            }
          }
        }
      }
    }

    return false;
  }

  private getAnomaliesNotYetCompletedFromReferenceDate(gaugingElement: GaugingElement, currentInspectionPlans: any[]) {
    const referenceDate = new Date(this.referenceDate);
    referenceDate.setHours(0, 0, 0, 0);

    return this.asset.anomalies.filter(anomaly => {
      if (anomaly.inspectionElementId !== gaugingElement.Guid) return false;
      
      const anomalyDate = new Date(anomaly.createdAt);
      anomalyDate.setHours(0, 0, 0, 0);
      
      if (anomaly.dateCompleted) {
        const completedDate = new Date(anomaly.dateCompleted);
        completedDate.setHours(0, 0, 0, 0);
        
        return completedDate >= referenceDate;
      }
      
      return true;
    });
  }

  private getRelevantChecklists(gaugingElement: GaugingElement, currentInspectionPlans: Partial<IInspectionPlan>[], hasChecklistDateInCurrentPlan: boolean): ChecklistItem[] {
    return gaugingElement.elementResult.CheckList.filter((c: ChecklistItem) => {
      if (!c.Date) return false;
      
      const checkListDate = new Date(c.Date);
      checkListDate.setHours(0, 0, 0, 0);
      
      if (currentInspectionPlans.length > 0 && hasChecklistDateInCurrentPlan) {
        return currentInspectionPlans.some(dateRange => {
          const startDate = new Date(dateRange.assetWindowStartsAt);
          const endDate = new Date(dateRange.assetWindowEndsAt);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          return checkListDate >= startDate && checkListDate <= endDate;
        });
      } else {
        const referenceDate = new Date(this.referenceDate);
        referenceDate.setHours(0, 0, 0, 0);
        return checkListDate <= referenceDate;
      }
    });
  }

  private hasChecklistDateInCurrentPlan(gaugingElement: GaugingElement, currentInspectionPlans: Partial<IInspectionPlan>[]): boolean {
    if (currentInspectionPlans.length === 0) return false;

    return gaugingElement.elementResult.CheckList.some(c => {
      if (!c.Date) return false;
      const checkListDate = new Date(c.Date);
      checkListDate.setHours(0, 0, 0, 0);
      
      return currentInspectionPlans.some(dateRange => {
        const startDate = new Date(dateRange.assetWindowStartsAt);
        const endDate = new Date(dateRange.assetWindowEndsAt);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        return checkListDate >= startDate && checkListDate <= endDate;
      });
    });
  }

  private getActiveAnomaliesInCurrentPlanOrLater(gaugingElement: GaugingElement, currentInspectionPlans: Partial<IInspectionPlan>[]) {
    return this.asset.anomalies.filter(anomaly => {
      if (anomaly.inspectionElementId !== gaugingElement.Guid || anomaly.dateCompleted) return false;
      
      const anomalyDate = new Date(anomaly.createdAt);
      anomalyDate.setHours(0, 0, 0, 0);
      
      const referenceDate = new Date(this.referenceDate);
      referenceDate.setHours(0, 0, 0, 0);
      
      if (currentInspectionPlans.length > 0) {
        return currentInspectionPlans.some(dateRange => {
          const startDate = new Date(dateRange.assetWindowStartsAt);
          const endDate = new Date(dateRange.assetWindowEndsAt);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          
          return anomalyDate >= startDate && anomalyDate <= endDate;
        });
      } else {
        return anomalyDate <= referenceDate;
      }
    });
  }

  private hasResolvedValueInRelevantChecklists(gaugingElement: GaugingElement, relevantChecklists: ChecklistItem[], currentInspectionPlans: Partial<IInspectionPlan>[]): boolean {
    if (relevantChecklists.length === 0) return false;

    const checklistItemsWithData = relevantChecklists.filter(c => {
      if (!c.Date) return false;
      
      const checkListDate = new Date(c.Date);
      checkListDate.setHours(0, 0, 0, 0);
      
      const isInScope = currentInspectionPlans.length > 0 ? 
        currentInspectionPlans.some(dateRange => {
          const startDate = new Date(dateRange.assetWindowStartsAt);
          startDate.setHours(0, 0, 0, 0);
          return checkListDate >= startDate;
        }) : 
        checkListDate <= new Date(this.referenceDate);

      if (!isInScope) return false;

      const hasValue = c.Value && c.Value.trim() !== '';
      const hasAttributes = c.AttributesList?.length > 0 && 
        c.AttributesList.some(attributeCategory => 
          attributeCategory.attributeScoreInfo?.some(scoreInfo => scoreInfo.selected)
        );
      
      return hasValue || hasAttributes;
    });

    if (checklistItemsWithData.length === 0) return false;

    const allChecklistItemsResolved = checklistItemsWithData.every(c => {
      if (c.Value === "OK") return true;

      if (c.AttributesList?.length > 0) {
        let hasSelectedAttributes = false;
        let allSelectedAttributesResolved = true;
        
        for (const attributeCategory of c.AttributesList) {
          if (attributeCategory.attributeScoreInfo) {
            for (const scoreInfo of attributeCategory.attributeScoreInfo) {
              if (scoreInfo.selected) {
                hasSelectedAttributes = true;
                if (scoreInfo.score > 0) {
                  allSelectedAttributesResolved = false;
                }
              }
            }
          }
        }
        
        return hasSelectedAttributes && allSelectedAttributesResolved;
      }

      return false;
    });

    if (!allChecklistItemsResolved) return false;

    const referenceDate = new Date(this.referenceDate);
    referenceDate.setHours(0, 0, 0, 0);
    
    const hasActiveAnomalies = this.asset.anomalies.some(anomaly => {
      if (anomaly.inspectionElementId !== gaugingElement.Guid || anomaly.dateCompleted) return false;
      
      const anomalyDate = new Date(anomaly.createdAt);
      anomalyDate.setHours(0, 0, 0, 0);
      
      if (currentInspectionPlans.length > 0) {
        return currentInspectionPlans.some(dateRange => {
          const startDate = new Date(dateRange.assetWindowStartsAt);
          const endDate = new Date(dateRange.assetWindowEndsAt);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(23, 59, 59, 999);
          return anomalyDate >= startDate && anomalyDate <= endDate;
        });
      } else {
        return anomalyDate <= referenceDate;
      }
    });

    return allChecklistItemsResolved && !hasActiveAnomalies;
  }

  private async checkAnomalies(gaugingElement: GaugingElement){
    let anomaliesIds = gaugingElement.elementResult.CheckList.filter(x => x.AnomalyId != "00000000-0000-0000-0000-000000000000").map(x => x.AnomalyId);

    for(let anomalyId of anomaliesIds){
      if(!this.asset.anomalies.map(x => x.id).includes(anomalyId)){
        let anomalies = await this.reloadAnomaly(anomalyId)
        if(anomalies.length > 0){
          this.asset.anomalies = this.asset.anomalies.concat(anomalies)
        }
      }
    }
  }

  private setUvsValuesToAnomalies(gaugingElement: GaugingElement) {
    // if ((gaugingElement.SurfaceDesign.geometry as any).uv != null) return gaugingElement;
    if ((gaugingElement.SurfaceDesign.geometry as any).uv == null) {
      if(gaugingElement.elementResult.ElementInfo.vertices.length > 0){
        let uvs = getUVSValues(gaugingElement.elementResult.ElementInfo.vertices, gaugingElement.targetElement);
        (gaugingElement.SurfaceDesign.geometry as THREE.BufferGeometry).setAttribute('uv', new THREE.BufferAttribute(uvs, 3));
        (gaugingElement.SurfaceDesign.geometry as THREE.BufferGeometry).setAttribute('position', new THREE.BufferAttribute(new Float32Array(gaugingElement.elementResult.ElementInfo.vertices), 3));
      }
      else{
        let vertices = this.convertIndexedToUnindexedPositions(gaugingElement.SurfaceDesign.geometry as THREE.BufferGeometry);
        let uvs = getUVSValues(vertices, gaugingElement.targetElement);

        const geometry = gaugingElement.SurfaceDesign.geometry as THREE.BufferGeometry;
        const nonIndexedGeometry = geometry.toNonIndexed();
        nonIndexedGeometry.computeVertexNormals();
        nonIndexedGeometry.computeBoundingBox();
        nonIndexedGeometry.computeBoundingSphere();
        gaugingElement.SurfaceDesign.geometry = nonIndexedGeometry;

        (gaugingElement.SurfaceDesign.geometry as THREE.BufferGeometry).setAttribute('uv', new THREE.BufferAttribute(uvs, 3));
        (gaugingElement.SurfaceDesign.geometry as THREE.BufferGeometry).setAttribute('position', new THREE.BufferAttribute(new Float32Array(vertices), 3));
      }
    }
    return gaugingElement
  }

  private hasValue(gaugingElement: GaugingElement) {
    for (const c of gaugingElement.checkList) {
      if (c.Value != "" && c.Value != "0" && c.Value != null) {
        return true;
      }
    }
    return false;
  }

  public shouldEstimateDegradationCurve(element: GaugingElement | ElementResultInfo): boolean {
    const elementResult = (element as GaugingElement)?.elementResult ?? (element as ElementResultInfo)
    const checklist = elementResult?.CheckList ?? (element as GaugingElement)?.checkList ?? []

    return elementResult?.InspectionTypeId === INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING
      && this.hasChecklistThicknessValue(checklist)
  }

  private hasChecklistThicknessValue(checklist: ChecklistItem[]): boolean {
    return (checklist ?? []).some(item => {
      if (item?.Value == null) {
        return false
      }

      const value = Number(item.Value)
      return !Number.isNaN(value) && value !== 0
    })
  }

  private convertIndexedToUnindexedPositions(geometry: THREE.BufferGeometry): number[] {
    // If geometry is already unindexed, return the positions directly.
    if (!geometry.index) {
      return Array.from(geometry.attributes.position.array);
    }

    const positions = geometry.attributes.position.array as Float32Array | number[];
    const indices = geometry.index.array as Uint16Array | Uint32Array | number[];
    const unindexedPositions = new Array<number>(indices.length * 3);

    // For each index, copy the corresponding vertex position (x, y, z)
    for (let i = 0; i < indices.length; i++) {
      const vertexIndex = indices[i] * 3;
      const outIndex = i * 3;
      unindexedPositions[outIndex] = positions[vertexIndex];
      unindexedPositions[outIndex + 1] = positions[vertexIndex + 1];
      unindexedPositions[outIndex + 2] = positions[vertexIndex + 2];
    }

    return unindexedPositions;
  }


  private hasOverThicknessValue(gaugingElement: GaugingElement, originalThickness: number = (gaugingElement.targetElement as StructuralElement)?.thickness): boolean {
    if(originalThickness == null) originalThickness = (gaugingElement.targetElement as StructuralElement)?.thickness

    if (originalThickness) {
      for (const c of gaugingElement.checkList) {
        const value = Number(c.Value)
        const isOverThickness = DegradationUtil.isOverthicknessValue(value, originalThickness)

        if (isOverThickness) {
          return true
        }
      }
    }
    return false;
  }

  public doesInspectionExistOnDate(gaugingElement: GaugingElement): boolean {
    let alreadyExists = false

    var endDate = new Date(new Date(gaugingElement.elementResult.EndDate?.toString()?.replace('Z', ''))?.toDateString())

    if (!gaugingElement.active && endDate &&
      endDate <= this.referenceDate &&
      gaugingElement.elementResult.EndDate &&
      !gaugingElement.elementResult.EndDate?.toString().includes('0001-01-01')) {
      gaugingElement.SurfaceDesign.visible = false
    }
    else {
      for (const c of gaugingElement.checkList) {
        let date = new Date(new Date(c.Date).toDateString())

        if (date <= this.referenceDate) {
          alreadyExists = true
          break
        }
      }
    }
    return alreadyExists
  }

  public toInspectInCurrentPlan(gaugingElement: GaugingElement) {
    var emptyValues = gaugingElement.checkList.filter(c => c.Value == null || c.Value == "" || Number(c.Value) == 0)

    if (emptyValues.length > 0) {
      var currentInspectionPlans = this.selectCurrentPlans(gaugingElement);

      for (var plan of currentInspectionPlans) {
        if (emptyValues.some(v => new Date(plan.assetWindowStartsAt) <= new Date(v.Date)
          && new Date(plan.assetWindowEndsAt) >= new Date(v.Date))) {
          return true
        }
      }
    }

    return false;
  }

  public toInspectInCurrentOrAfterPlan(gaugingElement: GaugingElement) {
    var emptyValues = gaugingElement.checkList.filter(c => c.Value == null || c.Value == "" || Number(c.Value) == 0)

    if (emptyValues.length > 0) {
      var inspectionPlans = this.plans.filter(p => p.inspectionTypeId == gaugingElement.elementResult.InspectionTypeId)

      var currentInspectionPlans = inspectionPlans.filter(p => new Date(p.assetWindowStartsAt).getTime() <= new Date(this.referenceDate).getTime()
        && new Date(p.assetWindowEndsAt).getTime() >= new Date(this.referenceDate).getTime())
      for (var plan of currentInspectionPlans) {
        if (emptyValues.some(v => new Date(plan.assetWindowStartsAt) <= new Date(v.Date)
          && new Date(plan.assetWindowEndsAt) >= new Date(v.Date))) {
          return true
        }
      }
    }

    return false;
  }

  public getAnomalyColor(anomaly: AnomalyModel, referenceDate: Date): string {
    let today = moment(referenceDate)
    let deadLine = anomaly.deadLine ? moment(anomaly.deadLine) : null

    const hasDateComplete: boolean = anomaly.dateCompleted != null
    const hasAction: boolean = anomaly.actionId != null && anomaly.actionId != '00000000-0000-0000-0000-000000000000'
    const actionResolvesAnomaly = anomaly.actionResolvesAnomaly

    let dateCompletedIsInThePast: boolean = false
    if (hasDateComplete) dateCompletedIsInThePast = new Date(anomaly.dateCompleted) <= new Date(referenceDate)



    if (hasDateComplete && dateCompletedIsInThePast && !hasAction) {
      return 'gray'
    }
    else if (hasDateComplete && dateCompletedIsInThePast && hasAction && actionResolvesAnomaly) {
      return 'gray'
    }
    else if (anomaly.deadLine) {
      if (anomaly.dateStarted && new Date(anomaly.dateStarted) <= referenceDate) {
        return 'orange'
      }
      if (anomaly.assetAlertRedDays && today.diff(deadLine, "days") < anomaly.assetAlertRedDays) {
        return 'red'
      }
      else {
        if (anomaly.assetAlertYellowDays && today.diff(deadLine, "days") < anomaly.assetAlertYellowDays) {
          return 'yellow'
        }
        else if (today.diff(deadLine, "months") <= 12) {
          return 'green'
        }
        else if (today.diff(deadLine, "months") <= 30) {
          return 'blue'
        }
        else return 'white'
      }
    }
    return 'red'
  }

  public setInspectionPointColor(gaugingElement: GaugingElement, v?: number) {
    if (v == null) {
      v = this.getLastInspectionMeasurement(gaugingElement)
    }

    if (gaugingElement.targetElement instanceof StructuralElement) {
      const hasValue = gaugingElement.checkList.some(c => c.Value != "" && c.Value != "0" && c.Value != null)
      const target = gaugingElement.targetElement as StructuralElement;
      if (v === 0 && !hasValue) gaugingElement.defaultMaterial = SteelThicknessGaugingPoint.emptyValueMaterial;
      else if (target.ruleThickness == 0 || target.ruleThickness == null) gaugingElement.defaultMaterial = SteelThicknessGaugingPoint.overThicknessMaterial;
      else if (v <= +(target.excessiveCorrosionThickness.toFixed(2))) gaugingElement.defaultMaterial = SteelThicknessGaugingPoint.excessiveCorrosionMaterial;
      else if (v <= +(target.substantialCorrosionThickness.toFixed(2))) gaugingElement.defaultMaterial = SteelThicknessGaugingPoint.substantialCorrosionMaterial;
      else if (v >= +((target.thickness * 1.1).toFixed(2))) gaugingElement.defaultMaterial = SteelThicknessGaugingPoint.overThicknessMaterial;
      else gaugingElement.defaultMaterial = SteelThicknessGaugingPoint.acceptableCorrosionMaterial;
    }
  }

  private getLastInspectionMeasurement(gaugingElement: GaugingElement): number {
    var v = 0;
    let index = 0;
    if (gaugingElement.checkList && gaugingElement.checkList && gaugingElement.checkList.length > 0) {
      gaugingElement.checkList = gaugingElement.checkList.sort((a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime())
      gaugingElement.checkList.forEach((checkList) => {
        let formattedDate = new Date(new Date(checkList.Date).toDateString())
        if (this.referenceDate >= formattedDate) {
          v = Number(gaugingElement.checkList[index]?.Value) ?? 0;
        }
        index++;
      })
    }
    return v
  }
  //#endregion


  //#region Baseboard

  documentsList = []
  currentAnomalyId: string

  showDegradationCurve: boolean = false;
  changedDateTimeline = new BehaviorSubject<Date>(new Date());
  plansTimelineLoaded = new BehaviorSubject<boolean>(false);

  displayDegradationCurveEvent: DisplayDegradationCurveEvent;

  async loadAllFilters() {
    this.filterService.getFiltersByRegionIds(this.asset.assetInfo.AssetId, this.currentRegionsIds).subscribe(data => {
      if (data?.length > 0) {
        for (let index = 0; index < data.length; index++) {
          let startDate = new Date(data[index].startDate)
          let endDate = new Date(data[index].endDate)

          data[index].startDate = startDate
          data[index].endDate = endDate
        }
        this.filterList = data
      }
    })
  }

  async loadPlansToTimeline() {
    this.plansTimelineLoaded.next(false);
    this.loadAllFilters()
    this.asset.repairsList = await this.loadRepairsToTimeline();
    this.asset.mitigationsList = await this.loadMitigationsToTimeline();
    var assetId = this.asset.assetInfo.AssetId;
    this.assetInfoViewService.castCurrentRegionIds
    .pipe(takeUntil(this.destroy$)).subscribe(async (data) => {
      var currentRegionsIds = data;
      if (!this.plans || (data.length == 1 && !this.plans.every(p => p.regionId == data[0]))) {
        this.plans = await this.inspectionService.getOpenedInspectionPlanByRegionId(assetId, currentRegionsIds).toPromise();
        this.listInspectionTypesToTimeline = this.GetAssetInspectionTypes();
        this.inspectionTypesToTimeline = await this.crudService.getCrudBasicDomainsInspectionList(this.listInspectionTypesToTimeline).toPromise();
      }
      this.plansTimelineLoaded.next(true);
    })

  }

  async loadHistoricalPlans() {
    var assetId = this.asset.assetInfo.AssetId;
    this.assetInfoViewService.castCurrentRegionIds
    .pipe(takeUntil(this.destroy$)).subscribe(async (data) => {
      var currentRegionsIds = data;
      if (!this.historicalPlans || (data.length == 1 && !this.historicalPlans.every(p => p.regionId == data[0]))) {
        this.historicalPlans = await this.inspectionService.getInspectionPlanByRegionId(assetId, currentRegionsIds).toPromise();
      }
    })
  }

  async loadFilters() {
    var assetId = this.asset.assetInfo.AssetId;
    this.assetInfoViewService.castCurrentRegionIds
    .pipe(takeUntil(this.destroy$)).subscribe(async (data) => {
      var currentRegionsIds = data;
      if (!this.filters || (data.length == 1 && !this.filters.every(p => p.regionId == data[0]))) {
        this.filters = await this.filterService.getFiltersByRegionIds(assetId, currentRegionsIds).toPromise();
      }
    })
  }

  getPlansAndClusters() : Partial<IInspectionPlan>[] {
    let clustersAsInspectionPlans : Partial<IInspectionPlan>[] = []
    if (this.filters && this.filters.length > 0) {
      clustersAsInspectionPlans = this.filters.filter(p => p.isCluster).map(c => 
      {
        let start = new Date(c.startDate);
        let end = new Date(c.endDate);

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        const diffTime = end.getTime() - start.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        if (diffDays < 1) {
          end = new Date(start);
          end.setDate(start.getDate() + 2);
          end.setHours(23, 59, 59, 999);
        }

        return {
          assetWindowStartsAt: start,
          assetWindowEndsAt: end,
          inspectionTypeId: c.inspectionTypeIds[0],
        }
      })
    }

    let plansAndClusters = Array.from([...(this.plans || []), ...clustersAsInspectionPlans]);
    return plansAndClusters;
  }

  public showBaseboard() {
    if (this.documentsList?.length > 0) {
      this.templateService.showGraphics = false;
      this.templateService.showBaseBoard = true;
      this.templateService.showInspectionList = false;
    }
  }

  public showGraphics() {
    this.templateService.showBaseBoard = false;
    this.templateService.showGraphics = true;
    this.templateService.showInspectionList = false;
    this.templateService.showTimeline = false;
    if (!this.templateService.showTimeline) {
      this.templateService.infoPositionOnBaseboardOpen = true;
    }
  }

  public showInspectionList() {
    this.templateService.showBaseBoard = false;
    this.templateService.showGraphics = false;
    this.templateService.showInspectionList = true;
  }

  setDocumentsList(data: any[]) {
    this.documentsList = data;
  }

  public async loadRepairsToTimeline() {
    if (this.asset.repairsList.length == 0) {
      const repairs = await this.anomalyService.getAnomalyRepairs().toPromise();
      this.asset.repairsList = repairs;
    }
    return this.asset.repairsList;
  }

  public async loadMitigationsToTimeline() {
    if (this.asset.mitigationsList.length == 0) {
      const mitigations = await this.anomalyService.getAnomalyActions().toPromise();
      this.asset.mitigationsList = mitigations;
    }
    return this.asset.mitigationsList;
  }

  public async handleSuccessAfterBatchChanges() {
    this.updateChangesWorkflow = true
    this.reloadProperties([this.currentRegionId])
  }

  //#endregion

  public updatePlansVisibilityBasedOnReferenceDate(plans: IInspectionPlan[]) {
    if (!plans || plans.length == 0) {
      return;
    }

    let selectedPlans: IInspectionPlan[] = [];
    let nonSelectedPlans: IInspectionPlan[] = [];

    plans.forEach(obj => {
      let start = new Date(obj.assetWindowStartsAt);
      let end = new Date(obj.assetWindowEndsAt);

      start.setUTCHours(0, 0, 0, 0);
      end.setUTCHours(23, 59, 59, 999);

      let date = new Date(this.referenceDate);

      let dateTime = date.getTime();
      let startDateTime = start.getTime();

      if (dateTime >= startDateTime) {
        selectedPlans.push(obj);
      } else {
        nonSelectedPlans.push(obj);
      }
    });

    if (nonSelectedPlans.length > 0) {
      nonSelectedPlans.forEach(x => {
        this.hideInspections(x.assetWindowStartsAt, x.assetWindowEndsAt, [x.inspectionTypeId])
      })
    }
    this.updateInspectionsVisibilityBasedOnReferenceDate();

    if (selectedPlans.length > 0) {
      selectedPlans.forEach(x => {
        this.showInspections(x.assetWindowStartsAt, x.assetWindowEndsAt, [x.inspectionTypeId])
      });
    }
  }

  public updateFiltersVisibilityBasedOnReferenceDate(filters: IFilter[]) {
    if (filters) {
      let selectedFilters: IFilter[] = [];
      let nonSelectedFilters: IFilter[] = [];

      filters.forEach(obj => {
        let start = new Date(obj.startDate);
        let end = new Date(obj.endDate);

        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 59, 999);

        let date = new Date(this.referenceDate);

        if (date >= start) {
          selectedFilters.push(obj);
        } else {
          nonSelectedFilters.push(obj);
        }
      });

      if (selectedFilters.length > 0) {
        selectedFilters.forEach(x => {
          this.showInspections(x.startDate, x.endDate, x.inspectionTypeIds)
        });
      }

      if (nonSelectedFilters.length > 0) {
        nonSelectedFilters.forEach(x => {
          this.hideInspections(x.startDate, x.endDate, x.inspectionTypeIds)
        })
      }
    }
  }

  public async showInspections(startDate: Date, endDate: Date, types: string[]) {
    const start = new Date(new Date(startDate).setHours(0, 0));
    const end = new Date(new Date(endDate).setHours(23, 59));
    this.asset.InspectionCampaigns.forEach((inspectionCollection) => {
      inspectionCollection.Elements.forEach((element) => {
        const gaugingElement = element as GaugingElement
        const gaugingElementEndDate = new Date(gaugingElement.elementResult.EndDate);
        if (gaugingElementEndDate.getFullYear() > 1 && this.referenceDate >= gaugingElementEndDate) {
          gaugingElement.SurfaceDesign.visible = false
          return
        }

        for (const checkList of gaugingElement.checkList) {
          let formattedDate = new Date(new Date(checkList.Date).toDateString())
          if (
            ((formattedDate >= start && formattedDate <= end) && (this.referenceDate >= formattedDate))
            && (types.includes(gaugingElement.inspectionTypeId))
          ) {
            gaugingElement.SurfaceDesign.visible = true
            break
          }
        }
      })
    })
  }

  public async hideAllInspections() {
    this.asset.InspectionCampaigns.forEach((inspectionCollection) => {
      inspectionCollection.Elements.forEach((element) => {
        const gaugingElement = element as GaugingElement
        gaugingElement.SurfaceDesign.visible = false
      })
    })
  }

  public async hideInspections(startDate: Date, endDate: Date, types: string[]) {
    const start = new Date(new Date(startDate).setHours(0, 0));
    const end = new Date(new Date(endDate).setHours(23, 59));

    this.asset.InspectionCampaigns.forEach((inspectionCollection) => {
      inspectionCollection.Elements.forEach((element) => {
        const gaugingElement = element as GaugingElement
        const gaugingElementEndDate = new Date(gaugingElement.elementResult.EndDate);
        if (gaugingElementEndDate.getFullYear() > 1 && this.referenceDate >= gaugingElementEndDate) {
          gaugingElement.SurfaceDesign.visible = false
          return
        }

        for (const checkList of gaugingElement.checkList) {
          let formattedDate = new Date(new Date(checkList.Date).toDateString())
          if (
            formattedDate >= start &&
            formattedDate <= end &&
            (types.includes(gaugingElement.inspectionTypeId))
          ) {
            gaugingElement.SurfaceDesign.visible = false
            break
          }
        }
      })
    })
  }

  public async updateInspectionsVisibilityBasedOnReferenceDate() {
    this.asset.InspectionCampaigns.forEach((inspectionCollection) => {
      inspectionCollection.Elements.forEach((element) => {
        const gaugingElement = element as GaugingElement
        const gaugingElementEndDate = new Date(gaugingElement.elementResult.EndDate);
        if (gaugingElementEndDate.getFullYear() > 1 && this.referenceDate >= gaugingElementEndDate) {
          gaugingElement.SurfaceDesign.visible = false
          return
        }
        for (const checkList of gaugingElement.checkList) {
          let formattedDate = new Date(new Date(checkList.Date).toDateString())
          if (
            new Date(this.referenceDate) >= formattedDate
          ) {
            gaugingElement.SurfaceDesign.visible = true
            break
          }
        }
      })
    })
  }

  public selectCurrentPlans(gaugingElement: GaugingElement) : Partial<IInspectionPlan>[] {
    if (!this.plans || !this.plans.length) {
      return [];
    }

    var inspectionPlans = [] as Partial<IInspectionPlan>[]
    inspectionPlans = this.plans?.filter(p => p.inspectionTypeId == gaugingElement.elementResult.InspectionTypeId)
    
    if (!inspectionPlans || !inspectionPlans.length) {
      return [];
    }

    var currentPlans = inspectionPlans.filter(p => {
      let referenceDate = new Date(this.referenceDate);
      referenceDate.setHours(0, 0, 0, 0);
      
      let startDateString = p.assetWindowStartsAt.toString();
      let start = new Date(startDateString + (startDateString.includes('Z') ? '' : 'Z'));
      start.setUTCHours(0, 0, 0, 0);
      
      let endDateString = p.assetWindowEndsAt.toString();
      let end = new Date(endDateString + (endDateString.includes('Z') ? '' : 'Z'));
      end.setUTCHours(23, 59, 59, 999);

      return referenceDate >= start && referenceDate <= end
    });

    return currentPlans;
  }

  selectCurrentPlansAndClusters(gaugingElement: GaugingElement, plansAndClusters: Partial<IInspectionPlan>[]) : Partial<IInspectionPlan>[] {
    if (!plansAndClusters || !plansAndClusters.length) {
      return [];
    }
    
    let inspectionPlans = plansAndClusters.filter(p => 
      p.inspectionTypeId == gaugingElement.elementResult.InspectionTypeId
    )

    var currentInspectionPlans = inspectionPlans.filter(p => {
      let referenceDate = new Date(this.referenceDate);
      referenceDate.setHours(0, 0, 0, 0);
      
      let startDateString = p.assetWindowStartsAt.toString();
      let start = new Date(startDateString + (startDateString.includes('Z') ? '' : 'Z'));
      start.setUTCHours(0, 0, 0, 0);
      
      let endDateString = p.assetWindowEndsAt.toString();
      let end = new Date(endDateString + (endDateString.includes('Z') ? '' : 'Z'));
      end.setUTCHours(23, 59, 59, 999);

      return referenceDate >= start && referenceDate <= end
    });

    return currentInspectionPlans;
  }

  public exportInvalidElements() {
    const assetId = this.asset.assetInfo.AssetId;
    this.assetService.getInvalidElements(assetId).subscribe((elements: any[]) => {
      if (elements.length > 0) {
        this.noticationService.addGeneratingNotification("Invalid Elements Report")

        const formattedElements = this.formatInvalidElementsToExport(elements)
        const url: string = ExcelService.exportAsExcelFile(formattedElements, "Elements")

        this.noticationService.addNotification("Document Ready", "", url)
      }
      else {
        this.noticationService.addNotification("No Invalid Elements Found")
      }
    },
      (err) => {
        console.log(`Error retrieving invalid elements from server ${err}`)

        this.noticationService.addErrorNotification("Exporting Document");
      })
    this.noticationService.addGettingNotification("Invalid Elements");
  }

  private formatInvalidElementsToExport(elements: any[]) {
    var result = [] as any[];
    for (let e of elements) {
      var regionId = e.RegionId;
      if (regionId == null && e.RegionIds.length > 0) {
        regionId = e.RegionIds[0]
      }

      var sectionName = this.asset?.assetInfo?.Sections?.find(x => x.id === e.SectionId)?.name;
      var regionName = this.asset?.assetInfo?.Regions?.find(x => x.id === regionId)?.name;
      var assetName = this.asset?.assetInfo?.Label;

      var dto: InvalidElementDTO = {
        TypeName: e.TypeName,
        Label: e.General?.Label,
        Id: e.id,

        Date: e.General?.Collection.Date,

        Thickness: e.Geometry?.Thickness,
        RuleThickness: e.Geometry?.RuleThickness,

        WebThickness: e.Geometry?.WebThickness,
        RuleWebThickness: e.Geometry?.RuleWebThickness,

        FlangeThickness: e.Geometry?.FlangeThickness,
        RuleFlangeThickness: e.Geometry?.RuleFlangeThickness,

        MaterialId: e.General?.MaterialId,
        MaterialType: e.General?.Material?.MaterialType,
        MaterialSubtype: e.General?.Material?.MaterialSubtype,


        AssetName: assetName,
        RegionName: regionName,
        SectionName: sectionName,

        // AssetId: e.AssetId,
        RegionId: regionId,
        SectionId: e.SectionId,
      }
      result.push(dto);
    }
    return result
  }

  //#region Risk

  /** Resolves false when a newer load or an invalidation superseded this one (its result is dropped). */
  private async loadLightModelRiskLevels(): Promise<boolean> {
    const seq = ++this._riskLevelsLoadSeq
    let result: RegionsAndSectionsRisk = await this.criticalAreaService
      .getRegionsAndSectionsRisk(null, this.asset.assetInfo.AssetId)
      .toPromise()

    let riskLevels = await this.riskLevelService.getRiskLevelItems(this.asset.assetInfo.CustomerId).toPromise()
    if (seq !== this._riskLevelsLoadSeq) {
      return false
    }
    if(riskLevels?.length > 0){
      this.riskLevels = riskLevels
    }
    this.regionsRiskLevels = result.regions
    this._riskLevelsLoaded = true

    // if (result?.regions?.length > 0) {
    //   let ranges: number[] = await this.criticalAreaService.getRedCriticalAreaRange(this.asset?.assetInfo?.CustomerId, this.asset?.assetInfo?.Type).toPromise()
    //   // if (ranges?.length == 2) {
    //     this.redRiskMaxArea = ranges[0]
    //     this.redRiskMinArea = ranges[1]

    //     // this.noticationService.addLoadedNotification("Risk");
    //     this.regionsRiskLevels = result.regions
    //   // }
    //   // else {
    //   //   this.noticationService.addNotification("Risk Ranges", "Not Found");
    //   // }
    // }
    // else {
    //   // this.noticationService.addNotification("Risk", "Not Found");
    // }
    return true
  }

  //#endregion

  public generateRiskLegend(regionsRiskLevels: RegionRisk[], riskLevels: RiskLevelItem[]): void {
    this.graphicsMaterials.generateRiskLegend(regionsRiskLevels, riskLevels);
  }

  public regenerateThicknessLegend(): void {
    this.graphicsMaterials.regenerateThicknessLegend(this.asset.GetStructureAndRepairsRegions());
  }

}
